<template name = "dateTemplate" lang="html">
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<h5>&nbsp;</h5>
				<a href="" id="sidebarMenuClose"><feather type="x" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
				<div v-if="properties.uid">
					<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id" class="has-text-weight-semibold">{{form.name}} 
								<!-- <div class="d-flex align-items-center justify-content-end"> -->
								<!-- <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span> -->
								<a v-if="form.name === '실험명'" href="#" @click="expNameHandler" style="margin-left: 6.5rem;" class="has-text-weight-semibold">IMPORT</a>
								<!-- </div>  -->
							</label>
							<input type="email" class="form-control" @keyup="headerDataChangeHandler" :name="form.id" v-model.lazy="experimentData[form.id]" :id="form.id" :placeholder="form.name">
						</div>
					</ul>
					<ul class="sidebar-nav" v-else-if="form.division === 'O'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == experimentData[form.id]">{{form1.codeName}}</span></p>
							<p class="mg-b-0 text-left" v-else>{{experimentData[form.id]}}</p>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label> 
							<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
								<input type="radio" @keyup="headerDataChangeHandler" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="experimentData[form.id]" class="custom-control-input" :checked="form1.codeCode == experimentData[form.id]">
								<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
							</div>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in dateRangeSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<!-- <p class="mg-b-0 text-left">{{experimentData[form.id]}}</p> -->
							<li class="nav-item">
								<date-picker v-model="form.fvalue" @dp-change="headerDataChangeHandler" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="From date" :id="form.fid" v-model.lazy="experimentData[form.fid]" aria-label="Search" ignoreReadonly/>
							</li>
							<li class="nav-item">
								<date-picker v-model="form.evalue" @dp-change="headerDataChangeHandler" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="To date" :id="form.eid" v-model.lazy="experimentData[form.eid]" aria-label="Search" ignoreReadonly/>
							</li>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<!-- <p class="mg-b-0 text-left">{{experimentData[form.id]}}</p> -->
							<date-picker v-model="form.value" @dp-change="headerDataChangeHandler" :config="datePickerOptions" class="form-control" autocomplete='off' :placeholder="form.name" :id="form.id" v-model.lazy="experimentData[form.id]" aria-label="Search" ignoreReadonly/>
						</div>
					</ul>
				</div>
				<div v-else>
					<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms" v-if="form.division === 'C'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id" class="has-text-weight-semibold">{{form.name}} 
								<!-- <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span> -->
								<a v-if="form.name == '실험명'" href="#" @click="expNameHandler" style="margin-left: 6.5rem;" class="has-text-weight-semibold">IMPORT</a>
							</label>
							<input type="email" class="form-control" @keyup="headerDataChangeHandler" :name="form.id" v-model.lazy="experimentData[form.id]" :id="form.id" :placeholder="form.name">
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in dateRangeSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<!-- <p class="mg-b-0 text-left">{{experimentData[form.id]}}</p> -->
							<li class="nav-item">
								<date-picker @dp-change="headerDataChangeHandler" v-model="form.fvalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="From date" :id="form.fid" v-model.lazy="experimentData[form.fid]" aria-label="Search" ignoreReadonly/>
							</li>
							<li class="nav-item">
								<date-picker @dp-change="headerDataChangeHandler" v-model="form.evalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="To date" :id="form.eid" v-model.lazy="experimentData[form.eid]" aria-label="Search" ignoreReadonly/>
							</li>
						</div>
					</ul>
					<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms " v-if="form.division === 'C'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id" class="has-text-weight-semibold">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
							<date-picker v-model="form.value" @dp-change="headerDataChangeHandler" :config="datePickerOptions" class="form-control" autocomplete='off' :placeholder="form.name" :id="form.id" v-model.lazy="experimentData[form.id]" aria-label="Search" ignoreReadonly/>
						</div>
					</ul>
				</div>
				<!--file upload-->
				<ul class="sidebar-nav">
		   			<li class="d-block mb-1 has-text-weight-semibold">Gel Image upload</li>
				</ul>
			
				<div>
					<!-- <form id='fileUpTest' method="POST" enctype="multipart/form-data"> -->
					<imgUpload @imgFileHandler="this.imgFileHandler"/>
					<!-- </form> -->
				</div>
				<div class="card card-body p-1 paste-background-color">
						<input type="text" @paste="onPaste" multiple="multiple" class="img-input paste-background-color" placeholder="Paste your images here"></input>
						<img id="pasteImg"/>
						<p id='countPasteImg' class='m-0'></p>
						<!-- <button type="button" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5"><i data-feather="image" class="wd-10 mg-r-5"></i>Upload</button> -->
				</div>

				<ul class="sidebar-nav" style="margin-top:10px">
		   			<li class="d-block mb-1 has-text-weight-semibold">NanoDrop Image upload</li>
				</ul>
			
				<div>
					<!-- <form id='fileUpTest' method="POST" enctype="multipart/form-data"> -->
					<nanoUpload @nanoFileHandler="this.nanoFileHandler"/>
					<!-- </form> -->
				</div>
				<div class="card card-body p-1 paste-background-color">
						<input type="text" @paste="onNanoPaste" multiple="multiple" class="img-input paste-background-color" placeholder="Paste your images here"></input>
						<img id="pasteNano"/>
						<p id='countPasteNano' class='m-0'></p>
						<!-- <button type="button" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5"><i data-feather="image" class="wd-10 mg-r-5"></i>Upload</button> -->
				</div>


				<!--file upload end-->
				<div v-if="menuStatus == '04000'" style="margin-top:10px">
					<!--tapeStation upload-->
					<ul class="sidebar-nav">
						<li class="d-block mb-1 has-text-weight-semibold">TapeStation Upload</li>
					</ul>
					<tapeUpload @tapeFileHandler="this.tapeFileHandler"/>
				</div>

				<div v-if="menuStatus == '04000'" style="margin-top:10px">
					<!--tapeStation upload-->
					<ul class="sidebar-nav">
						<li class="d-block mb-1 has-text-weight-semibold">BioAnalyzer Upload</li>
					</ul>
					<bioUpload @bioFileHandler="this.bioFileHandler"/>
				</div>

				<!--file upload-->
				<ul class="sidebar-nav" style="margin-top:10px">
		   			<li class="d-block mb-1 has-text-weight-semibold">Report upload</li>
				</ul>
			
				<div>
					<!-- <form id='fileUpTest' method="POST" enctype="multipart/form-data"> -->
					<pdfUpload @pdfFileHandler="this.pdfFileHandler"/>
					<!-- </form> -->
				</div>
					<!-- <div class="card card-body">
						<form id='tapeupload' method="POST" enctype="multipart/form-data">
							<input class="upload" type="file" name="file" ref="file" multiple="multiple" @change="tapeFileSelect($event.target.name, $event.target.files)" @drop="tapeFileSelect($event.target.name, $event.target.files)">
							<p id='countTape'>Drag your files here or click in this area.</p>
						</form>
					</div> -->
					<!--file upload end-->
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components pd-b-0-f overflow-hidden">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
								<li class="breadcrumb-item active" aria-current="page">Detail</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} Detail</h4>
						</nav>
					</div>
					<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
						<!--<router-link class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" :to="{name:'editor', params:{experimentHeader:experimentHeader, experimentData:experimentData, menuData:menuData, sampleData:this.editorSampleData, dprops:this.properties, type:'list'}}"><feather type="printer" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Report</router-link>-->
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="reportEditor()"><feather type="printer" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Report</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-if="!appButtonFlag && properties.uid" @click="approval()"><feather type="user-check" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Approval</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-if="appButtonFlag" v-on:click="confirmData()"><feather type="folder" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Confirm</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="createData(true, 'create')"><feather type="folder" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Save</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-if="properties.uid" v-on:click="deleteData()"><feather type="delete" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>delete</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="goPage()"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>List</button>
					</div>
				</div>

				<!-- <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f"><feather type="user-check" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Approval</button> -->

				<div class=" pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="col-sm-6 col-lg-5 d-inline-block">
						<ul class="cardborder nav nav-tabs" id="myTab" role="tablist"> <!-- 상단 tab (현재단계 / 이전단계검체 / Plate) -->
							<li class="nav-item"><a class="nav-link active" id="experiment-tab" data-toggle="tab" href="#experiment" role="tab" aria-controls="experiment" aria-selected="true" @click="rendertab()">Experiment</a></li>
							<li class="nav-item"><a class="nav-link" id="samples-tab" data-toggle="tab" href="#samples" role="tab" aria-controls="samples" aria-selected="false">Samples</a></li>
						</ul>
					</div>
					<div class="d-inline-block" style="max-width: 57%;width: 100%;text-align: right;">
						<button v-if="this.downloadList.QC.length > 0" @click="reportDialogHandler()" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>QC_Report</button>
						<button v-if="imgData.length > 0" data-toggle="collapse" data-target="#ViewGel" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f"><feather type="image" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Gel</button>
						<!-- <feather v-if="imgData.length > 0" type="image" data-toggle="collapse" data-target="#ViewGel" class="svg_overflow svg-cursor"></feather> -->
						<div class="gel-container">
							<div class="row">
								<div class="cart">
									<div v-draggable class="items-list collapse" style="max-width:1500px;" v-bind:style="{width: ((imgData.length*180)+(imgData.length*20))+'px'}" id="ViewGel">
										<div style="white-space:nowrap; overflow-x:scroll;" class="viewer-scroll">
											<imageViewer :image="imgData"  @deleteImgFile="this.deleteImgFile"/>
										<div class="chart-three clearfix">
											<div id="flotChart5" class="flot-chart ht-30"></div>
										</div>
										</div>
										<div class="row">
											<div class="view-cart">
												<span class="close-cart" data-toggle="collapse" data-target="#ViewGel">Close</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<button v-if="nanoData.length > 0" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f" data-toggle="collapse" data-target="#ViewNano"><nanoIcon fill="white" class="wd-15 hd-15 mg-r-5 "></nanoIcon>NANO DROP</button>
						<div class="gel-container">
							<div class="row">
								<div class="cart">
									<div v-draggable class="items-list collapse" style="max-width:1500px;" v-bind:style="{width: ((nanoData.length*180)+(nanoData.length*20))+'px'}" id="ViewNano">
										<div style="white-space:nowrap; overflow-x:scroll;" class="viewer-scroll">
											<imageViewerNano :image="nanoData" @deleteImgFile="this.deleteImgFile"/>
										<div class="chart-three clearfix">
											<div id="flotChart5" class="flot-chart ht-30"></div>
										</div>
										</div>
										<div class="row">
											<div class="view-cart">
												<span class="close-cart" data-toggle="collapse" data-target="#ViewNano">Close</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<button v-if="tapeData.length > 0" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f" data-toggle="collapse" data-target="#ViewTape"><tapeIcon fill="white" class="wd-15 hd-15 mg-r-5 "></tapeIcon>TAPE STATION</button>
						<div class="tape-container">
							<div class="row">
								<div class="cart">
									<div v-draggable class="items-list2 collapse viewer-scroll" id="ViewTape">
										<imageViewerTape :image="tapeData" @deleteTapeFile="this.deleteTapeFile"/>
										<div class="chart-three clearfix">
											<div id="flotChart5" class="flot-chart ht-30"></div>
										</div>
										<div class="chart-three clearfix">
											<div id="flotChart5" class="flot-chart ht-30"></div>
										</div>
										<div class="row">
											<div class="view-cart">
												<span class="close-cart" data-toggle="collapse" data-target="#ViewTape">Close</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<button v-if="bioData.length > 0" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f" data-toggle="collapse" data-target="#ViewBio"><tapeIcon fill="white" class="wd-15 hd-15 mg-r-5 "></tapeIcon>BIO ANALYZER</button>
						<div class="tape-container">
							<div class="row">
								<div class="cart">
									<div v-draggable class="items-list2 collapse viewer-scroll" id="ViewBio">
										<imageViewerBio :image="bioData" @deleteBioFile="this.deleteBioFile"/>
										<div class="chart-three clearfix">
											<div id="flotChart5" class="flot-chart ht-30"></div>
										</div>
										<div class="chart-three clearfix">
											<div id="flotChart5" class="flot-chart ht-30"></div>
										</div>
										<div class="row">
											<div class="view-cart">
												<span class="close-cart" data-toggle="collapse" data-target="#ViewBio">Close</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card card-body pd-b-0-f">
						<div class="tab-content" id="myTabContent">
							<div class="tab-pane fade lm-overflow show active" id="experiment" role="tabpanel" aria-labelledby="experiment-tab">
								<div class="d-none d-md-block tx-right-f">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="this.checkAll"><feather type="check" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>all checked</a>
									<!-- <download-excel class = "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" :data = "excelData" :fields = "excelHeader" worksheet = "My Worksheet" name = "filename.xls">EXCEL</download-excel> -->
									<a href="#modal6" v-if="firstExpBool" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="minus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>division</a>
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="this.sampleDelColumn"><feather type="minus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>delete</a>
								</div>
								<ul class="nav nav-line mg-b-0-f" id="myTab5" role="tablist"><!-- 현재 단계 검체 확인 tab (이전단계검체 / 현재단계) -->
									<li class="nav-item" v-for="(form, i) in tabHeader" v-if="properties.mid === form.id"><a class="nav-link active" @click='classifySampleHeader' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a></li>
									<li class="nav-item" v-else><a class="nav-link"  @click='classifySampleHeader' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false">{{form.menuName}}</a></li>
								</ul>
								<hot-table id='sample-table' :settings="sheetSettings" :data="sampleData" class="ht-hot-table zero-index" ref="sheet" :afterChange="changeData"></hot-table>
							</div><!-- tab -->
							<div class="tab-pane fade" id="samples" role="tabpanel" aria-labelledby="samples-tab">
								<div class="d-none d-md-block tx-right-f">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" @click="sampleAddColumn"><feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add</a>
								</div>
									<ul class="nav nav-line mg-b-0-f" id="myTab5" role="tablist"> <!-- 이전 단계 및 현재 단계 재실험 확인 tab (이전단계 / 현재단계(재실험)) -->
										<li class="nav-item" v-for="(form, i) in tabHeader" v-if="(tabHeader.length - 2) === i">
											<a class="nav-link active" @click="classifyWorkChange(form.id)" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true" >{{form.menuName}}</a>
										</li>
										<!--<li class="nav-item" v-else-if="(tabHeader.length - 1) === i">
											<a class="nav-link" @click="classifyWorkChange(form.id)" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false" >Re-Experiment</a>
										</li>-->
									</ul>
								<section>
									<b-table id='preTable' :data="isEmpty ? [] : preData" :checked-rows.sync="checkedRows" ref="table" striped checkable detailed paginated per-page="40" detail-key="id" :show-detail-icon="false" :opened-detailed="defaultOpenedDetails" @details-open="(row, index) => closeAllOtherToggle(row, index)"> <template slot-scope="props">
											<b-table-column v-for="(form, i) in preHeader" v-if="Number(i) == 0" :key="form.id" :custom-key="form.id" field="no" :label="'No'" centered>{{props.row.no}}</b-table-column>
											<b-table-column v-else-if="Number(i) == 1" :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>
												<!-- <a href='#modal5' @click='sendId(props.row.id)' :id="props.index" data-toggle="modal" data-animation="effect-flip-horizontal"> {{ props.row[form.columnCode] }} </a> -->
												<a href='#' @click='toggle(props.row)' :id="props.index"> {{ props.row[form.columnCode] }} </a>
											</b-table-column>
											<b-table-column v-else :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>{{props.row[form.columnCode]}}</b-table-column>
										</template>
										<template slot="empty">
											<section class="section">
												<div class="content has-text-grey has-text-centered">
												<p>Nothing here.</p>
												</div>
											</section>
											</template>
											<template slot="detail" slot-scope="props">
											<ul class="nav nav-line" id="myTab5" role="tablist"> <!-- 이전 단계 그룹 내 단계별 검체 정보 확인 tab -->
												<li class="nav-item" v-for="(form, i) in tabHeader" v-if="form.id == re_expid">
													<a class="nav-link active" @click="classifyPreSampleHeader" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a>
												</li>
												<li class="nav-item" v-else-if="re_expid.length == 0 && i == tabHeader.length-2">
													<a class="nav-link active" @click="classifyPreSampleHeader" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="false">{{form.menuName}}</a>
												</li>
												<li class="nav-item" v-else-if="(tabHeader.length - 2) >= i">
													<a class="nav-link" @click="classifyPreSampleHeader" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="false">{{form.menuName}}</a>
												</li>
											</ul>
											<b-table id="preSampleTable" :columns="preSampleHeader" :data="isEmpty ? [] : preSampleData" :checked-rows.sync="sampleCheckedRows" ref="preSampleTable" hoverable striped checkable></b-table>
											</template>
									</b-table>
									<div class='d-none'><b-table id='preSampleTable' ref="sampleTable"></b-table></div>
								</section>
							</div><!-- tab -->
						</div>
					</div><!-- card -->
					<!-- <div :class="{'display-width30': b_sh_well, 'd-none': !b_sh_well}"> -->
					<div class="df-settings" :class="{'show': b_sh_well, '': !b_sh_well}">
						<div v-on:click="ptshow()" class="df-settings-link closed-cursor text-vertical-3">PLATE</div>
						<div class="df-settings-body">
							<div class="card card-body">
								<div class="mg-t-10 mg-sm-t-0">
									<h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-0-f">Plate Well</h6>
									<div v-for='idx in well_plate' :id="'d-idx-'+idx" class='d-none'>
										<ul class="plate-board">
											<li class="fl tc w1 plate-list2 mg-t-10-f">({{idx}})</li>
											<li class="fl tc w1 plate-list2 mg-t-10-f" v-for='column in well_column'>{{(Number(column))}}</li>
										</ul>
										<!--- 리스트 --->
										<ul class="plate-board" v-for='row in well_row'>
											<li class="fl tc plate-w2 plate-list2 pt-sm-2">{{well_row_a[(Number(row)-1)]}}</li>
											<div :id="'list'+idx+'-'+row">
												<li class="fl tc plate-w2 list1 pt-sm-2"  v-for='column in well_column' :id='well_row_a[(Number(row)-1)]+column'>
													<div>{{well_row_a[(Number(row)-1)]}}{{(Number(column))}}</div>
												</li>
											</div>
										</ul>
									</div>
								</div>
							</div>
							<!-- <div class="card card-body">test</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="modal5" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel5" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered chat-width" role="document">
				<div class="modal-content tx-14 chat-height">
					<div class="modal-header">
					<h6 class="modal-title" id="exampleModalLabel5">Chat</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
					</div>
					<div class="modal-body">
						<Chat></Chat>
					</div>
				</div>
			</div> 	
		</div><!-- chat modal -->
		<div class="modal fade" id="modal6" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel6" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content tx-14">
					<div class="modal-header">
						<h6 class="modal-title" id="exampleModalLabel6">Sample Division</h6>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<p class="mg-b-0">Please enter the number of samples to division.</p>
						<p class="mg-b-0">&nbsp;</p>
						<p class="mg-b-0"><input type="number" min='1' max='100' id='addNum' class="form-control"></p>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary tx-13" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-primary tx-13" data-dismiss="modal" @click="sampleDivision()">Division</button>
					</div>
				</div>
			</div>
		</div><!-- division modal -->

		<v-app id="inspire">
            <div>
                <v-row
                    justify="center"
                >
                    <v-dialog
                    v-model="reportDialog"
                    max-width="500px"
                    style='z-index:20001;'
                    >
                        <v-card>
                            <v-card-title>
                            Download Report
                            </v-card-title>
                            <v-card-text>
                            <v-select
                                v-model="selectReport"
                                :items="downloadList['QC']"
                                label="Select a report"
                                item-value="text"
                            ></v-select>
                            </v-card-text>
                            <v-card-actions>
                            <v-btn
                                color="secondary"
                                text
                                @click="reportDialog = false"
                            >
                                Close
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="loadQC_Report()"
                            >
                                Load
                            </v-btn>
                            <v-btn
                                color="accent"
                                text
                                @click="deleteQC_DialogHandler()"
                            >
                                Delete
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </div> 	
        </v-app>

		 <v-app id="inspire">
			<v-row justify="center">
				<v-dialog
					v-model="deleteDialog"
					persistent
					max-width="290"
				>
					<v-card>
					<v-card-title class="text-h6">
						Are you sure you want to delete?
					</v-card-title>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
						color="secondary"
						text
						@click="deleteDialog = false"
						>
						Cancel
						</v-btn>
						<v-btn
						color="primary"
						text
						@click="deleteQC_Report()"
						>
						OK
						</v-btn>
					</v-card-actions>
					</v-card>
				</v-dialog>
			</v-row>
		</v-app>
	</div> <!-- this body end -->
</template>
<script>
	// 에디트 기능 handsontable 사용 시 임포트
	import Handsontable from 'handsontable';
	import {HotTable} from '@handsontable/vue';
	import 'handsontable-key-value';
	// 공통 함수 관리 파일 임포트
	import common from '@/views/Common/common.js';
	import imgUpload from '@/views/Common/image-upload/imgUpload'
	import tapeUpload from '@/views/Common/image-upload/tapeUpload'
	import bioUpload from '@/views/Common/image-upload/bioUpload'
	import nanoUpload from '@/views/Common/image-upload/nanoUpload'
	import pdfUpload from '@/views/Common/pdf-upload/pdfUpload'

	// 멀티 드래그 앤 드롭 임포트
	import Sortable, {Swap} from 'sortablejs';
	Sortable.mount(new Swap());
	// Header의 메뉴 정보 호출을 위한 bus event
	import {bus} from '../../main';
	// import Approval from "@/views/Common/Approval";
	import Chat from "@/views/Common/Chat";

	// 이미지 드래거블
	import { Draggable } from 'draggable-vue-directive'

	// 달력 관련 
	import datePicker from "vue-bootstrap-datetimepicker";
	import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
	// 날짜 변환
	import moment from "moment";
	// 이미지 뷰어
	import imageViewer from "@/views/Common/image-upload/Viewer";
	import imageViewerNano from "@/views/Common/image-upload/ViewerNano";
	import ImageViewerTape from "@/views/Common/image-upload/ViewerTape";
	import ImageViewerBio from "@/views/Common/image-upload/ViewerBio";
	import nanoIcon from '@/assets/svg/nano_w-01.svg';
	import tapeIcon from '@/assets/svg/tapestation_w-01.svg';
	
	// 경고창, 컨펌창
	import { Buefy } from 'buefy';
	export default {
		name: 'Detail',
		props: ['properties'],
		directives: {Draggable,},
		data(){
			return{
			
				// date setting
				datePickerOptions: {
					format: "YYYY-MM-DD",
					useCurrent: false,
					showTodayButton: true,
					keepInvalid: false,
					ignoreReadonly: true
				},
				mainName:'',
				subName:'',
				menuData:[], // header.vue data
				menuStatus: '',

				mid:'', // menu list id
				msid:'', // menu sheet id
				uid:'', // sheet id
				ssid:'', // sample list id
				rowNum:'', // sample group row number
				re_expid: '',
				premid: '',

				/* Experiment input Form */
				experimentHeader:[], // 입력 값 header column
				inputSearchForms:[], // 입력 input form
				dateSearchForms:[], // 입력 date form
				dateRangeSearchForms:[], // 입력 date range form
				checkboxSearchForms:[], // 입력 radio form

				/* Experiment 정보 Form Value */
				experimentData: [], // 실험 정보 확인
				defaultExperimentData: [], // 화면에 처음 접속 시 유지된 실험 정보 (데이터 저장 시 수정 사항 체크에 필요)
				editorSampleData: [], // 리포트 출력 전달하는 데이터

				/* tab Header */
				tabHeader:[],
				// sheetCoulumns:[],

				/* 이전 단계 Sample 정보 */
				preHeader:[],
				preData:[],
				preDefaultData:[],
				preSampleHeader:[],
				preSampleData:[],
				preDefaultSampleData:[],
				preDetail:[],
				checkedRows:[], // 그룹 체크 row 확인
				checkedRowData:[], // add 이전 체크 sample row 확인
				sampleCheckedRows:[], // sample 체크 row 확인
				isEmpty: false,
				addData:[],
				defaultOpenedDetails:[],
				
				/* 데이터 변경 여부 sample add 등 Handsontable에 행위가 없어도 저장할 수 있도록 */
				isWork: 0,

				/* Sample Form */
				sampleHeader:[], // Experiment Sample Header
				sampleData:[], // Experiment Sample list data
				// sampleData:[1,2,3,4,5,6,7,8,9,10],
				
				dafaultSampleData:[], // 화면에 처음 접속 시 유지된 Sample 정보 (데이터 저장 시 수정 사항 체크에 필요)
				sampleChangeData:[], // Sample의 변경 정보
				boolChange: false, // 데이터 변경 유무 확인
				preDetail:[],

				/* Well Plate index */
				well_column:12,
				well_row:8,
				well_row_a:['A','B','C','D','E','F','G','H'],
				well_data:[],
				well_plate:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50],
				b_sh_well: false,

				/* Loading */
				isLoading: false,
				isFullPage: true,

				isCheckAll: false,

				excelHeader:{},
				excelData:[],
				json_meta: [[{'key': 'charset','value': 'utf-8'}]],

				/* file upload */
				formData:'',
				uFlag: false,
				imgData:[],
				imgId: [],
				pasteFlag: false,
				pasteCount:0,
				pasteForm: new FormData,
				

				/*idx */
				maxDivIdx:[],
				maxReIdx:[],
				maxIdx: [],

				/* approval */
				appButtonFlag: false,
				userData:{},
				
				/* tapeStation */
				tapeFlag: false,
				tapeData:[],
				tapeId: [],
				tapeFileFormData: new FormData,
				tapeFileHandleFlag: false,
				
				/* bioStation */
				bioFlag: false,
				bioData:[],
				bioId: [],
				bioFileFormData: new FormData,
				bioFileHandleFlag: false,
				

				/* menuRoute === experiments && menusort === 1 */
				firstExpBool: false,

				readonlyRow: [],

				width: 0,
				height: 0,

				imgFileFormData: new FormData,
				imgFileHandleFlag: false,

				// pdf
				pdfFlag: false,
				pdfData:[],
				pdfId: [],
				pdfFileFormData: new FormData,
				pdfFileHandleFlag: false,
				
				/* nanodrop */
				nanoFileFormData: new FormData,
				nanoFileHandleFlag: false,
				nanoData:[],
				nanoId: [],
				pasteNanoFlag: false,
				pasteNanoCount:0,
				pasteNanoForm: new FormData,

				/* pipeline array */
				pipeline: [],

				expNames:[],
				receptionNameColumnCode: '',
				expNameColumnCode: '',
				expName:'',

				/* QC Report */
				reportDialog: false,
				deleteDialog: false,
				selectReport: '',
				downloadList: {
					"QC": [],
				},
			}
		},
		beforeDestroy(){
			bus.$off('menu_data');
			window.removeEventListener("scroll", this.onScroll);
		},
		created(){
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.getPipeline();				
				this.classifyHeader();
				this.classifySampleHeader();
				this.classifyData();
				this.classifyPreDefaultData();
				this.getImgFile();
				this.getTapeFile();
				this.getPdf();
				this.getBioFile();
			});
			bus.$on('userinfo', (data)=>{
				this.userData = data;

				if (data.official == 'CC069') {
					this.appButtonFlag = true;
				}
			});
			window.addEventListener('resize', this.handleResize);
			this.handleResize();
		},
		destroyed(){
			window.removeEventListener('resize', this.handleResize);
		},
		mounted() {
			this.$nextTick(function (){
				$("#gelimage").draggable();
				$("#tapeimage").draggable();
				$("#bioimage").draggable();
			});
			window.addEventListener("scroll", this.onScroll);
		},
		components: {
			HotTable,
			Chat,
			datePicker,
			moment,
			imageViewer,
			imageViewerNano,
			ImageViewerTape,
			ImageViewerBio,
			imgUpload,
			tapeUpload,
			bioUpload,
			nanoUpload,
			pdfUpload,
			nanoIcon,
			tapeIcon
		},
		methods: {
			headerDataChangeHandler() {
				this.boolChange = true;
			},
			makeExpNames(samples) {
				if (samples.length > 0) {
					let expNames = [];
					let s = samples;
					for (let i = 0; i < s.length; i++) {
						expNames.push(s[i][this.receptionNameColumnCode]);
					}
					expNames = Array.from(new Set(expNames));
					let name = '';
					for (let i = 0; i < expNames.length; i++) {
						if (i == 0) {
							name = expNames[i];
						} else {
							name += '_' + expNames[i];
						}
					}
					if (this.expName != '') {
						this.expName += '_'+name;
					} else {
						this.expName = name;
					}
					return name;
				} else {
					return false;
				}
			},
			expNameHandler() {
				document.getElementById(this.expNameColumnCode).value = this.expName;
				this.experimentData[this.expNameColumnCode] = this.expName;
			},
			imgFileHandler(files) {
				if (files.length > 0) {
					let tForm = new FormData();
					for (let i in files) {
						tForm.append('file', files[i])
					}
					let formData = new FormData();
					for (let pair of tForm.entries()) {
						formData.append(pair[0], pair[1]);
					}
					// formData.append('uid', this.properties.uid);
					// formData.append('copyId', this.imgId);
					this.imgFileFormData = formData;
					this.imgFileHandleFlag = true;
					this.boolChange = true;
				} else {
					this.imgFileHandleFlag = false;
				}
			},
			tapeFileHandler(files) {
				if (files.length > 0) {
					let tapeForm = new FormData();
					for (let i in files) {
						tapeForm.append('file', files[i])
					}
					let formData = new FormData();
					for (let pair of tapeForm.entries()) {
						formData.append(pair[0], pair[1]); 
					}
					// formData.append('uid', this.properties.uid);
					// formData.append('copyId', this.imgId);
					this.tapeFileFormData = formData;
					this.tapeFileHandleFlag = true;
					this.boolChange = true;
				} else {
					this.tapeFileHandleFlag = false;
				}
			},
			bioFileHandler(files) {
				if (files.length > 0) {
					let bioForm = new FormData();
					for (let i in files) {
						bioForm.append('file', files[i])
					}
					let formData = new FormData();
					for (let pair of bioForm.entries()) {
						formData.append(pair[0], pair[1]); 
					}
					// formData.append('uid', this.properties.uid);
					// formData.append('copyId', this.imgId);
					this.bioFileFormData = formData;
					this.bioFileHandleFlag = true;
					this.boolChange = true;
				} else {
					this.bioFileHandleFlag = false;
				}
			},
			nanoFileHandler(files) {
				if (files.length > 0) {
					let nanoForm = new FormData();
					for (let i in files) {
						nanoForm.append('file', files[i])
					}
					let formData = new FormData();
					for (let pair of nanoForm.entries()) {
						formData.append(pair[0], pair[1]); 
					}
					// formData.append('uid', this.properties.uid);
					// formData.append('copyId', this.imgId);
					this.nanoFileFormData = formData;
					this.nanoFileHandleFlag = true;
					this.boolChange = true;
				} else {
					this.nanoFileHandleFlag = false;
				}
			},

			/*
			* QC Report 
			*/
			pdfFileHandler(files) {
				if (files.length > 0) {
					// if (files.length > 1) {
					// 	this.$buefy.dialog.alert({
					// 		message: '한 개의 파일만 업로드할 수 있습니다.',
					// 		size: 'is-medium',
					// 		type: 'is-danger'
					// 	})
					// }
					let tForm = new FormData();
					for (let i in files) {
						tForm.append('file', files[i])
					}
					let formData = new FormData();
					for (let pair of tForm.entries()) {
						formData.append(pair[0], pair[1]);
					}
					// formData.append('uid', this.properties.uid);
					// formData.append('copyId', this.imgId);
					this.pdfFileFormData = formData;
					this.pdfFileHandleFlag = true;
					this.boolChange = true;
				} else {
					this.pdfFileHandleFlag = false;
				}
			},

			async getPdf(){
				try {
					if(!common.isNull(this.properties.uid)){
						let params = [];
						params = {
							'id' : this.properties.uid
						};
						let request = {params : params};
						const result = await this.$axios.get(`${this.$apiHost}/files/pdf`, request);
					
						if (result.data.length > 0) {
							let path = [];
							for (let i of result.data) {
								path.push(i.fileName)
								this.pdfId.push(i.id)
							}
							this.downloadList.QC = path;
							this.downloadList.QC_info = result.data;
						}
						return false;
					} else {
						return false;
					}

				} catch (error) {
					console.log(error);
				}
			},
			async reportDialogHandler(){
				this.reportDialog = true;
				return false;
			},
			/*
			* QC Report 
			*/
			async loadQC_Report(){
				try {
					if (this.selectReport) {
						let path = `https://lims.accugenelab.com/pdf/QC_Report/${this.selectReport}`;
						window.open(path);

						this.selectReport = '';
						this.reportDialog = false;

						return false;
					} else {
						this.$buefy.dialog.alert({
							message: 'Please select a report',
							size: 'is-medium',
							type: 'is-danger'
						})
						return false;
					}

				} catch (error) {
					console.log(error);
				}
			},
			async deleteQC_DialogHandler(){
				this.deleteDialog = true;
				return false;
			},
			/*
			* QC Report 
			*/
			async deleteQC_Report(){
				try {
					if (this.selectReport) {
						let params = []; 
						let deleteReport = this.downloadList.QC_info.find(item => item.fileName === this.selectReport);
						let { id, fileName } = deleteReport;
						params = {
							id, 
							fileName,
						};
						let request = {params : params}
						const deleteData = await this.$axios.delete(`${this.$apiHost}/files/qc`, request);
						// list
						this.downloadList.QC = this.downloadList.QC.filter(item => item !== this.selectReport);
						// copy id 
						this.pdfId = this.pdfId.filter(item => item !== id);
						this.selectReport = '';
						this.deleteDialog = false;
						return false;
					} else {
						this.$buefy.dialog.alert({
							message: 'Please select a report',
							size: 'is-medium',
							type: 'is-danger'
						})
						deleteDialog = false;
						return false;
					}

				} catch (error) {
					console.log(error);
				}
			},
			/*
			* Load Data Reception Headers
			*/
			async classifyHeader(){
				let data = common.menuHeader(this.properties.mid, this.menuData);
				[
					this.mainName, 
					this.subName, 
					this.msid, 
					this.experimentHeader, 
					this.menuStatus,
				] = data;

				this.tabHeader = common.tabOrder(this.properties.mid, this.menuData);
				this.inputSearchForms = [];
				this.dateSearchForms = [];
				this.checkboxSearchForms = [];
				this.menuData.some(a=>{
					a.subs.some(b=>{
						if(b.menuSort === 1){
							if(b.menuRoute === 'experiments'){
								if(b.id === this.properties.mid) {
									this.firstExpBool = true;
									return true;
								}
							}
						}
					});
				});
				for(let i in this.experimentHeader){
					if(this.experimentHeader[i].columnType == "LIST"){
						if(this.experimentHeader[i].columnAttr =='statecode'){
							this.inputSearchForms.push({'name':this.experimentHeader[i].columnName, 'value':this.experimentHeader[i].code, 'id':this.experimentHeader[i].columnCode ,'division':'O', 'attr':this.experimentHeader[i].columnAttr});

						}else{
							this.checkboxSearchForms.push({'name':this.experimentHeader[i].columnName, 'id':this.experimentHeader[i].columnCode, 'value':this.experimentHeader[i].code, 'division':this.experimentHeader[i].columnDivision, 'attr':this.experimentHeader[i].columnAttr});
						}
					}else if(this.experimentHeader[i].columnType == "DATE"){
						if(!common.isNull(this.properties.uid)){
							this.dateSearchForms.push({'name':this.experimentHeader[i].columnName, 'value':'', 'id':this.experimentHeader[i].columnCode, 'division':this.experimentHeader[i].columnDivision, 'attr':this.experimentHeader[i].columnAttr});
						}else{
							if(this.experimentHeader[i].columnDivision == 'C'){
								this.dateSearchForms.push({'name':this.experimentHeader[i].columnName, 'value':'', 'id':this.experimentHeader[i].columnCode, 'division':this.experimentHeader[i].columnDivision, 'attr':this.experimentHeader[i].columnAttr});
							}
						}
					} else if (this.experimentHeader[i].columnType == "DATERANGE") {
						this.dateRangeSearchForms.push({name: this.experimentHeader[i].columnName,id: this.experimentHeader[i].columnCode,fvalue: "",evalue: "",fid: "f_" + this.experimentHeader[i].columnCode,eid: "e_" + this.experimentHeader[i].columnCode});
						this.experimentData[this.experimentHeader[i].columnCode] = {};
						this.experimentData[this.experimentHeader[i].columnCode].fvalue = '';
						this.experimentData[this.experimentHeader[i].columnCode].evalue = '';
					}else if(this.experimentHeader[i].columnType == "COUNT"){
					}else if(this.experimentHeader[i].columnType == "PIPELINE"){
						if(this.experimentHeader[i].columnAttr =='pipeline'){
							this.inputSearchForms.push({'name':this.experimentHeader[i].columnName, 'value':this.experimentHeader[i].code, 'id':this.experimentHeader[i].columnCode ,'division':'O', 'attr':this.experimentHeader[i].columnAttr});
						}else{
							this.checkboxSearchForms.push({'name':this.experimentHeader[i].columnName, 'id':this.experimentHeader[i].columnCode, 'value':this.experimentHeader[i].code, 'division':this.experimentHeader[i].columnDivision, 'attr':this.experimentHeader[i].columnAttr});
						}
					}else{
						if(this.experimentHeader[i].columnName == 'No'){
						}else{
							if (this.experimentHeader[i].columnName == '실험명') {
								this.expNameColumnCode = this.experimentHeader[i].columnCode;
							}
							if(!common.isNull(this.properties.uid)){
								this.inputSearchForms.push({'name':this.experimentHeader[i].columnName, 'value':'', 'id':this.experimentHeader[i].columnCode, 'division':this.experimentHeader[i].columnDivision, 'attr':this.experimentHeader[i].columnAttr});
							} else {
								if(this.experimentHeader[i].columnDivision == 'C'){
									this.inputSearchForms.push({'name':this.experimentHeader[i].columnName, 'value':'', 'id':this.experimentHeader[i].columnCode, 'division':this.experimentHeader[i].columnDivision, 'attr':this.experimentHeader[i].columnAttr});
								}
							}
						}
					}
				}
			},
			/*
			* Load Headers & Samples Data
			*/
			async classifyData(){
				this.openLoading();
				var thisData = [];
				var sampleData = [];
				var last_plate = common.find_last_column(this.sampleHeader, 'plate');
				if(!common.isNull(this.properties.uid)){
					var params = [];
					params = {'ssid' : this.ssid};
					params['uid'] = this.properties.uid;
					params['mid'] = this.properties.mid;
					var request = {params : params};

					await this.$axios.get(this.$apiHost + '/experiments/detail', request)
					.then(res=>{
						this.experimentData = res.data;
						for(let i in res.data) this.defaultExperimentData[i] = res.data[i]; // 불필요한 저장을 방지 하기 위하여 처음 불러온 데이터를 배열에 넣어준다 (key:value)
						let expName = '';
						expName = this.makeExpNames(res.data.samples);
					}).catch(err=>{console.log(err)});
					this.editorSampleData = common.makeData_r(this.experimentData.samples, 1);
					sampleData = common.makeData(this.experimentData.samples, 0);
					this.excelData = common.makeData(this.experimentData.samples, 1);
					// sampleData 96개 이상인 경우 plate 개수 추가
					let plate_row = sampleData.length%96 > 0 ? parseInt(sampleData.length/96) + 1 : parseInt(sampleData.length/96);
					for(let i = 0;i<plate_row;i++) document.getElementById('d-idx-'+(Number(i) + 1)).classList.toggle('d-none');
					for(let i in sampleData){
						this.maxDivIdx.push(sampleData[i].maxdividx);
						this.maxReIdx.push(sampleData[i].maxreidx);
						sampleData[i].No = Number(i) + 1;
						thisData = thisData.concat(false);
						for(let j in this.sampleHeader){
							if (j == 0) {
								thisData = thisData.concat(sampleData[i].No);
								thisData = thisData.concat(sampleData[i].sampleId);
							}
							if(this.sampleHeader[j].columnType === 'LIST'){
								if(this.sampleHeader[j].mid != this.properties.mid){
								if(!common.isNull(sampleData[i][this.sampleHeader[j].columnCode])){
									for(let k in this.sampleHeader[j].code){
										if(sampleData[i][this.sampleHeader[j].columnCode] === this.sampleHeader[j].code[k].codeCode){
											thisData = thisData.concat(this.sampleHeader[j].code[k].codeName);
										}
									}
								}else{
									thisData = thisData.concat('');
								}
								}else{
								thisData = thisData.concat(sampleData[i][this.sampleHeader[j].columnCode]);
								
								}
							}else{
								if (this.sampleHeader[j].columnAttr === 'receptionno') thisData = thisData.concat(sampleData[i][this.sampleHeader[j].columnCode]);
								else thisData = thisData.concat(sampleData[i][this.sampleHeader[j].columnCode]);
							}
							// columnAttr이 plate 인경우 plate 위치를 찾아서 넣어준다.
							let colorCode = this.$randomColor();
							let plate = 0;
							this.well_plate.some(a => {
								if(Number(i)+1 <= a*96){
									plate = a;
									return true;
								}
							});
							// if(this.sampleHeader[j].columnAttr === 'plate'){
							// 	if(last_plate === this.sampleHeader[j].columnCode){
							// 		if(sampleData[i][this.sampleHeader[j].columnCode] && sampleData[i][this.sampleHeader[j].columnCode].indexOf('-') > 0){
							// 			// let id = 'list'+plate.toString()+'-'+(Number(this.well_row_a.indexOf(sampleData[i][this.sampleHeader[j].columnCode].substring(0,1)))+1);
							// 			let dash_idxof = sampleData[i][this.sampleHeader[j].columnCode].indexOf('-')
							// 			let id = 'list' + sampleData[i][this.sampleHeader[j].columnCode].substring(0,dash_idxof) +'-'+ (Number(this.well_row_a.indexOf(sampleData[i][this.sampleHeader[j].columnCode].substr(Number(dash_idxof)+1,1)))+1)
							// 			let list = document.getElementById(id);
							// 			list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(Number(dash_idxof)+2,sampleData[i][this.sampleHeader[j].columnCode].length))-1].innerText = Number(i)+1;
							// 			list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(Number(dash_idxof)+2,sampleData[i][this.sampleHeader[j].columnCode].length))-1].style.color = '#ffffff';
							// 			list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(Number(dash_idxof)+2,sampleData[i][this.sampleHeader[j].columnCode].length))-1].style.backgroundColor = colorCode;
							// 		}
							// 	}
							// }
						}
						thisData = thisData.concat(sampleData[i].duid);
						this.sampleData.push(thisData);
						this.dafaultSampleData.push(thisData);
						thisData = [];
					}
				}
				this.rendertab();
				this.platetab();
				this.isLoading = false;
			},
			/*
			* Previous Group Header
			*/
			async classifyPreHeader(tabbool){
				let mid = '';
				if(common.isNull(this.re_expid)){
					if(!common.isNull(event.target.id)){
						if(event.target.id === this.properties.mid) mid = this.properties.mid;
						else mid = common.preMid(this.properties.mid, this.menuData);
					}else{
						if(this.re_expid.length > 0) mid = this.re_expid;
						else mid = common.preMid(this.properties.mid, this.menuData);
					}
				}else{
					if(this.re_expid === this.properties.mid) mid = this.properties.mid;
					else mid = common.preMid(this.properties.mid, this.menuData);
				}
				// this.preHeader.splice(0, this.preHeader.length); // splice 로 삭제할 경우 vue 이벤트 처리는 되지만, 상속한 부모 배열 값 까지 모두 제거되는 문제가 생긴다.
				this.preHeader = [];
				if(tabbool) this.$refs.table.newColumns.splice(0, this.$refs.table.newColumns.length);
				this.preHeader = common.menuHeader(mid, this.menuData)[3];
				this.classifyPreData();
			},
			/*
			* Previous Group Data
			*/
			async classifyPreData(){
				this.preData = [];
				this.preData = common.makeData(this.preDefaultData, 1, this.addData); // {data, (0: code, 1:name), checkdata}
				for (let i in this.preData) {
					for (let j in this.preHeader) {
						if (this.preHeader[j].columnName === 'Total' && this.preHeader[j].columnType === 'COUNT') {
							this.preData[i][this.preHeader[j].columnCode] = this.preData[i].samples.length;
						}
					}
				}
			},
			/*
			* Previous Sample Header
			*/
			async classifyPreSampleHeader(){
				let tempPreheader = [];
				let mid = '';
				if(!common.isNull(event.target.id)){
					mid = event.target.id.replace(/[0-9]/g, "");
				}else {
					mid = common.preMid(this.properties.mid, this.menuData);
				}
				

				if(mid.length === 0){
					if(common.isNull(this.re_expid)) {
						mid = common.preMid(this.properties.mid, this.menuData);
					}else {
						mid = this.re_expid;
					}
				}else{
					// mid = common.preMid(this.properties.mid, this.menuData);
 					mid = event.target.id;
				}

				if(!common.isNull(mid)){
					this.preSampleHeader = [];
					if(common.isNull(this.re_expid)) tempPreheader = common.makeHeader(common.preMid(this.properties.mid, this.menuData), this.menuData,2)[1];
					else tempPreheader = common.makeHeader(this.re_expid, this.menuData,2)[1];

					this.preHeader.forEach(a=>{
						tempPreheader.some((b, c)=>{
							if(a.columnCode == b.columnCode) delete tempPreheader[c];
						});
					});

					for(let i in tempPreheader){
						if(i == 0) this.preSampleHeader.push({'field': 'no', 'label':'No', 'centered':true})//샘플탭 샘플 상세보기에 넘버링 라벨 추가
						if(tempPreheader[i].columnAttr == 'receptionno') this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
						if(mid === tempPreheader[i].mid){
							if(tempPreheader[i].columnAttr != 'receptionno') this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
						}
						if(common.isNull(tempPreheader[i].mid)) this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
					}
				}
				this.classifyPreSampleData();
			},
			/*
			* Previous Sample Data
			*/
			async classifyPreSampleData(){
                let rowNum = event.target.id.replace(/[0-9]/g, "");
				if(rowNum.length === 0){
					if(!common.isNull(event.target.id)){
						rowNum = event.target.id;
						this.rowNum = rowNum;
					}else{
						rowNum = this.rowNum;
					}
				}else{
					rowNum = this.rowNum;
				}
				this.preDefaultSampleData = common.thisZeroDataSplice(this.preDefaultSampleData);
				this.preSampleData = [];
				this.preSampleData = common.makeData(this.preDefaultSampleData[rowNum], 1, this.addData); // {data, (0: code, 1:name), checkdata}
				for (let i in this.preSampleData) { //샘플탭 샘플 상세보기에 넘버링 값 추가
						this.preSampleData[i].no = Number(i) + 1;
				}
				if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[rowNum])){
					this.sampleCheckedRows = this.preSampleData;
				}else{
					this.sampleCheckedRows = [];
				}
			},
			/*
			* First Load Previous Data & Samples Data
			*/
            async classifyPreDefaultData(tabbool){
				this.openLoading();
				let mid = '';
				let reexp = '';
				if(common.isNull(this.re_expid)){
					if(!common.isNull(event.target.id)){
						if(event.target.id === this.properties.mid) mid = common.nextMid(this.properties.mid, this.menuData);
						else mid = this.properties.mid;
					}else{
						if(this.re_expid.length > 0) mid = this.re_expid;
						else mid = this.properties.mid;
					}
				}else{
					if(this.re_expid === this.properties.mid){
						mid = common.nextMid(this.properties.mid, this.menuData);
						reexp = 'r'
					}else{ 
						mid = this.properties.mid;
					}
				}
				this.preDefaultData = [];
				this.preSampleData = [];
				this.preDefaultSampleData = [];
				this.defaultOpenedDetails = [];
				var params = [];
				params = {mid : mid, reexp: reexp};
				// params = {'mid' : mid};
				var request = {params : params}
				await this.$axios.get(this.$apiHost + '/experiments/prestep', request)
				.then(res=>{
					for(let i in res.data){
						res.data[i].no = Number(i)+1;
						this.preDefaultData.push(res.data[i]);
						for(let j in res.data[i].samples){
							this.preDetail[res.data[i].samples[j].sampleId] = res.data[i].samples[j].duid;
							res.data[i].samples[j].gid = res.data[i].id;
						}
						this.preDefaultSampleData.push(res.data[i].samples);
					}
				}).catch(err=>{console.log(err)})
                // 이전 단계 (실험 대상), 현재 단계 (재실험 대상)에 배열에 데이터 세팅             
                
				if(mid === this.properties.mid){
					// 이전 단계 (실험 대상 조화 - 결과가 PASS 만 조회)
					this.preDefaultSampleData = common.remove_default_sample(mid, this.menuData, this.preDefaultSampleData, '');
					this.preDefaultData = common.remove_default(this.preDefaultData);
				}else{
					// 현재 단계 (재실험 대상 조회 - 결과가 없고 R > 0 만 조회)
                    this.preDefaultSampleData = common.remove_default_sample(mid, this.menuData, this.preDefaultSampleData, 'R');
                    this.preDefaultData = common.remove_default(this.preDefaultData);
                    
				}
				if(tabbool) this.classifyPreHeader(tabbool);
				else this.preSetting();
				this.isLoading = false;
			},
			/*
			* First Load Previous Data & Samples Data
			*/
			async classifySampleHeader(){
				let thisMid = event.target.id;
				if(common.isNull(thisMid)) thisMid = this.properties.mid;
				let data = common.makeHeader(this.properties.mid,this.menuData,2);
				this.ssid = data[0];
				this.sampleHeader = data[1];
				// this.sheetCoulumns = this.sampleHeader.filter(item => item.mid == thisMid);
				this.sheetSettings.hiddenColumns.columns = [2]
				this.$refs.sheet.settings.columns = [];
				this.$refs.sheet.settings.colHeaders = [];
				let idx = 3; // column hidden 을 위한 값
				for(let i in this.sampleHeader){
					if(Number(i) === 0){
						// i === 0
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat("");
						this.$refs.sheet.settings.columns.push({sampleData:'checkbox', type:'checkbox', width:'20px'});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('No');
						this.$refs.sheet.settings.columns.push({sampleData:'No', type:'text', readOnly: true, width:'30px'});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('id');
						this.$refs.sheet.settings.columns.push({sampleData:'id', type:'text', width:'20px', readOnly: true});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat(this.sampleHeader[i].columnName);
						if (this.sampleHeader[i].columnAttr === 'receptionno') {
							this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, renderer: this.anchorRenderer, readOnly: true});
						} else {
							this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
						}
					}else{
						// i > 0
						if (this.sampleHeader[i].columnAttr === 'receptionname') {
							this.receptionNameColumnCode = this.sampleHeader[i].columnCode;
						} 
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat(this.sampleHeader[i].columnName);
						if(this.sampleHeader[i].columnType === 'LIST'){
							var source = [];
							for(let j in this.sampleHeader[i].code){
								if (j == 0) {
									source.push({id:null, name:''});
								}
								source.push({id:this.sampleHeader[i].code[j].codeName, name:this.sampleHeader[i].code[j].codeName});
							}
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: true});
								}
							}else{
								this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'key-value', filter:false, source: source, keyProperty: 'id', valueProperty: 'name',});
							}
						}else if(this.sampleHeader[i].columnType === 'DATE'){
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}
							}else{
								this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'date', dateFormat:'YYYY-MM-DD'});
							}
						} else if (this.sampleHeader[i].columnType === 'FIGURE') {
							this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', renderer: this.figureRenderer});
						} else if (this.sampleHeader[i].columnType === 'PIPELINE') {
							this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'key-value', filter:false, source: this.pipeline, keyProperty: 'id', valueProperty: 'name',});
						} else {
							// columnType === String
							if(this.properties.mid != this.sampleHeader[i].mid){
								if(!common.isNull(this.sampleHeader[i].mid)){
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}else{
									if(this.sampleHeader[i].columnAttr === 'sampleid') this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text', readOnly: true});
								}
							}else{
								if (this.sampleHeader[i].columnDivision == 'O') {
									this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: true});
								} else {
									if(this.sampleHeader[i].columnAttr === 'plate') this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text',readOnly: true});
									else this.$refs.sheet.settings.columns.push({sampleData:this.sampleHeader[i].columnCode, type:'text'});
								}
							}
						}
					} 
					if(i > 0){
						if(thisMid != this.sampleHeader[i].mid){
							if(!common.isNull(this.sampleHeader[i].mid)){
								// 실험 내 화면에서 탭 선택 시 Handsontable column 숨기기 할 것
								// 샘플 바코드정보와 샘플 이름정보는 필터링
								if(this.sampleHeader[i].columnAttr != 'samplename' && this.sampleHeader[i].columnAttr != 'samplebarcode') this.sheetSettings.hiddenColumns.columns.push((Number(i)+Number(idx)));
							}
						}
					}
					this.excelHeader[this.sampleHeader[i].columnName] = this.sampleHeader[i].columnCode;
				}
				this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat('did');
				this.$refs.sheet.settings.columns.push({sampleData:'detailId', type:'text', readOnly: true});
				
				this.sheetSettings.hiddenColumns.columns.push(Number(this.$refs.sheet.settings.columns.length)-1);
				this.rendertab();
			},
			/*
			* Sample Add Column
			*/
			async sampleAddColumn(){
				this.openLoading();
				let insert_row = [];
				let remove_row = [];
				if(this.addData.length > 0){
					this.checkedRowData.forEach((a,b)=>{
						insert_row.push(common.makeHeaderData(this.preDefaultData, a, a.gid));
					});
					common.a_overlap_c(this.addData);
					this.addData.forEach(a=>{
						insert_row.some((c,d)=>{
							if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
								if(a.detailId === c.detailId){
									remove_row.push(d);
									return true;
								}
							}else{
								if(a.sampleId === c.sampleId){
									remove_row.push(d);
									return true;
								}
							}
						});
					});
					remove_row.sort((a,b)=>{ return b - a;});
					remove_row.forEach(a=>{
						insert_row.splice(a,1);
					});
					insert_row.forEach(a=>{
						this.addData.push(a);
					});
				}else{
					this.checkedRowData.forEach((a,b)=>{
						insert_row.push(common.makeHeaderData(this.preDefaultData, a, a.gid));
						this.addData.push(a);
					});
				}
				let detailHeader = common.menuHeader(this.properties.mid, this.menuData, 2)[3];
				if(this.re_expid === this.properties.mid){
					insert_row.forEach(a=>{
						detailHeader.forEach(b=>{
								a[b.columnCode] = '';
							// 
						});
					})
				}
				// 위에서 만든 insert_row를 sampleHeader(Experiment 테이블 헤더) 순서에 맞춰 Handsontable에 데이터를 넣어준다
				// ref는 검색을 통하면 어떠한 기능인지 확인 가능
				// Handsontable 은 sheet라는 배열에 담겨 있다. 실제로 vue 에서 get, set 할수 있는 Function은 hotInstance에 있다 (Handsontable API에서 말하는 core 부분이 hotInstance 이다.)
				let scode = common.find_sid_code(this.sampleHeader, 'sampleid');
				let divcode = common.find_sid_code(this.sampleHeader, 'divisionidx');
				let recode = common.find_sid_code(this.sampleHeader, 'reexpidx');
				let last_plate = common.find_last_column(this.sampleHeader, 'plate');
				let plate_row = (this.sampleData.length + insert_row.length)%96 > 0 ? parseInt((this.sampleData.length + insert_row.length)/96) + 1 : parseInt((this.sampleData.length + insert_row.length)/96);
				for(let i = 0;i<plate_row;i++){
					if(document.getElementById('d-idx-'+(Number(i) + 1)).classList.contains('d-none')){
						document.getElementById('d-idx-'+(Number(i) + 1)).classList.toggle('d-none');
					}
				}
				this.makeExpNames(insert_row);
				insert_row.forEach((a,b)=>{
					let sampleData = [];
					let pre_plate_m = '';
					let plate = 0;
					this.well_plate.some(a => {
						if(Number(this.sampleData.length)+1 <= a*96){
							plate = a;
							return true;
						}
					});
					sampleData.push(false);
					sampleData.push(this.sampleData.length+1);
					sampleData.push(a.sampleId);

					this.sampleHeader.forEach((c,d)=>{
						if(c.columnAttr === 'plate'){
							let pre_plate_s = '';
							let colorCode = this.$randomColor();
							let division = !a[divcode] ? '' : 'D'+a[divcode];
							let re_experiment = !a[recode] ? '' : 'R'+a[recode];
							if(c.columnCode === last_plate){
								if(common.isNull(pre_plate_m)){
									// plate 등록 순서는 A1, B1, C1, ... H12 순서로 넣는다고 함 (실험 시 기본 노하우)
									outer: for(let j=0; j<this.well_column; j++){
										inner: for(let k=0; k<this.well_row; k++){
											let list = document.getElementById('list'+plate+'-'+(k+1));
											if(list.childNodes[j].innerText.replace(/[0-9]/g, '') != ''){
											// if(list.childNodes[j].innerText.length < 4){
												// list.childNodes[j].innerText = a[scode]+division+re_experiment;
												list.childNodes[j].innerText = this.sampleData.length+1;
												list.childNodes[j].style.color = '#ffffff';
												list.childNodes[j].style.backgroundColor = colorCode;
												sampleData.push(plate+'-'+this.well_row_a[k]+(Number(j)+1));
												break outer;
											}
										}
									}
								}else{
									pre_plate_s = pre_plate_m;
									let dash_idxof = pre_plate_s.indexOf('-')
									let id = 'list' + pre_plate_s.substring(0,dash_idxof) +'-'+ (Number(this.well_row_a.indexOf(pre_plate_s.substr(Number(dash_idxof)+1,1)))+1)
									let list = document.getElementById(id);
									// if(list.childNodes[Number(pre_plate_s.substr(Number(dash_idxof)+2,pre_plate_s.length))-1].innerText.replace(/[0-9]/g, '') != ''){
									// 	list.childNodes[Number(pre_plate_s.substr(Number(dash_idxof)+2,pre_plate_s.length))-1].innerText = this.sampleData.length+1;
									// 	list.childNodes[Number(pre_plate_s.substr(Number(dash_idxof)+2,pre_plate_s.length))-1].style.color = '#ffffff';
									// 	list.childNodes[Number(pre_plate_s.substr(Number(dash_idxof)+2,pre_plate_s.length))-1].style.backgroundColor = colorCode;
									// 	sampleData.push(pre_plate_s);
									// }else{
									// 	// plate 등록 순서는 A1, B1, C1, ... H12 순서로 넣는다고 함 (실험 시 기본 노하우)
									// 	outer: for(let j=0; j<this.well_column; j++){
									// 		inner: for(let k=0; k<this.well_row; k++){
									// 			let listes = document.getElementById('list'+plate+'-'+(k+1));
									// 			if(listes.childNodes[j].innerText.replace(/[0-9]/g, '') != ''){
									// 				listes.childNodes[j].innerText = this.sampleData.length+1;
									// 				listes.childNodes[j].style.color = '#ffffff';
									// 				listes.childNodes[j].style.backgroundColor = colorCode;
									// 				sampleData.push(plate+'-'+this.well_row_a[k]+(Number(j)+1));
									// 				break outer;
									// 			}
									// 		}
									// 	}
									// }
								
								}
							}else{
								pre_plate_m = a[c.columnCode];
								pre_plate_s = pre_plate_m;
								sampleData.push(pre_plate_s);
							}
						}else{
							if (c.columnAttr === 'divisionidx') { //디비전 초기값 
								sampleData.push((common.isNull(a[c.columnCode])?0:a[c.columnCode]));
							} else if (c.columnAttr === 'reexpidx') {
								sampleData.push((common.isNull(a[c.columnCode])?0:a[c.columnCode]));
							} else {
								sampleData.push(a[c.columnCode]);
							}
						}
					});
					sampleData["headerId"] = a.headerId
					//sampleData.push(a.detailId); 왜 이렇게??, 사용처는 어디
					sampleData["prevDetailId"] = a.detailId
					this.sampleData.push(sampleData);
				})
				// 데이터 변경 여부
				this.isWork++;
				// preSampleSetting 를 실행하는 이유는 데이터가 입력 되고 samples(buefy table)을 다시 render 하기 위하여 실행
				this.preSetting();
				this.preSampleSetting();
				this.isLoading = false;
			},
			/*
			* Sample Delete Column
			*/
			async sampleDelColumn(){
				let last_plate = common.find_last_column(this.sampleHeader, 'plate');
				this.$buefy.dialog.confirm({
					message: 'All unsaved sample divisions and reexperiments are deleted. Are you sure you want to delete?',
					size: 'is-medium',
					onConfirm: async () => {
						this.openLoading();
						const colCnt = this.$refs.sheet.hotInstance.countRows();
						const colArray = [];
						const divArray = [];
						const divDelArray = [];
						const backpre = [];
						const last_plate_idx = Number(common.find_last_column_idx(this.sampleHeader, 'plate'))+3;
						var params = [];
						const allData = this.$refs.sheet.hotInstance.getData();
						let splitCount = 0;
						let plate_row = (colCnt)%96 > 0 ? parseInt(colCnt/96) + 1 : parseInt(colCnt/96);
						let del_detail = [];
						// Handsontable 데이터 삭제, 삭제 전 colArray 배열에 데이터를 미리 저장하여 addData있는 데이터를 splice 한다.
						for(let i=(colCnt-1); i >= 0; i--){
							if(this.$refs.sheet.hotInstance.getDataAtCell(i,0)){
								colArray[i] = this.$refs.sheet.hotInstance.getData(i,Number(this.$refs.sheet.hotInstance.countCols())-1,i,0)[0];
								this.$refs.sheet.hotInstance.alter('remove_row', i, 1);
							}
						}
						colArray.forEach(a=>{
							if(!common.isNull(a[a.length-1])) del_detail.push({detailId: a[a.length-1], sampleId: a[2], reexp: a[Number(common.find_sid_idx(this.sampleHeader, 'reexpidx'))+3]});
							this.$refs.sheet.hotInstance.getData().forEach((b, c)=>{
								if(a[2] == b[2]){
									divArray.push(c);
									divDelArray.push(b[last_plate_idx]);
									if(!common.isNull(a[a.length-1])) del_detail.push({detailId: a[a.length-1], sampleId: a[2],reexp:a[Number(common.find_sid_idx(this.sampleHeader, 'reexpidx'))+3]});
								}
							});
							
						});

						// 분할 정보 삭제
						divArray.sort();
						divArray.reverse();
						divArray.sort().forEach(a=>{
							this.$refs.sheet.hotInstance.alter('remove_row', a, 1)
							})

						// addData splice를 위하여 colArray sort 내림 차순 정렬 // addData는 검체(sample)의 중복 체크를 위한 배열
						colArray.sort(function(a, b){
							return a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0;
						});
						// addData splice를 위하여 addData sort 오름 차순 정렬
						this.addData.sort(function(a, b){
							return b - a;
						});

						let noDelArr = [];
						// addData splice
						for(let i in colArray){
							for(let j in this.addData){
								if(!common.isNull(colArray[i][colArray[i].length-1])){ //colArray[i][colArray[i].length-1] -> detail id 같음
									if(colArray[i][colArray[i].length-1] === this.addData[j].detailId) {
										this.addData.splice(j,1);
									}
								}else{ //dna 
									if(colArray[i][2] === this.addData[j].sampleId) {
										this.addData.splice(j,1);
									}
								}
							}
							// Platewell에 입력된 데이터 제거 
							let del_plate = colArray[i][1];
							for(let l=0; l < plate_row; l++){
								for(let j=0; j < this.well_column; j++){
									for(let k=0; k < this.well_row; k++){
										let list = document.getElementById('list'+(Number(l)+1)+'-'+(Number(k)+1));
										if(del_plate == list.childNodes[j].innerText){
											list.childNodes[j].innerText = this.well_row_a[k]+(Number(j)+1);
											list.childNodes[j].style.color = '#4a4a4a';
											list.childNodes[j].style.backgroundColor = '#ffffff';
										}else{
											if(list.childNodes[j].innerText.replace(/[0-9]/g, '') == '') noDelArr.push([Number(l)+1, Number(k)+1, j, list.childNodes[j].innerText]);
										}
									}
								}
							}
						}

						for(let i in divDelArray){
							for(let l=0; l < plate_row; l++){
								for(let j=0; j < this.well_column; j++){
									for(let k=0; k < this.well_row; k++){
										let list = document.getElementById('list'+(Number(l)+1)+'-'+(Number(k)+1));
										let del_plate = (Number(l)+1)+'-'+this.well_row_a[k]+(Number(j)+1);
										if(divDelArray[i] == del_plate){
											list.childNodes[j].innerText = this.well_row_a[k]+(Number(j)+1);
											list.childNodes[j].style.color = '#4a4a4a';
											list.childNodes[j].style.backgroundColor = '#ffffff';
										}
									}
								}
							}
						}


						// 삭제 후 No의 Numbering 재설정 (속도 저하 - 20.06.25 (변경)) , Plate well 위치 변경 포함
						var noChgArr = this.$refs.sheet.hotInstance.getData();
						for(let i = 0; i < this.$refs.sheet.hotInstance.countRows(); i++){
							noDelArr.some(a => {
								if(noChgArr[i][1] == a[3]){
									let list = document.getElementById('list'+a[0]+'-'+a[1]);
									list.childNodes[a[2]].innerText = Number(i)+1;
									return true;
								}
							});
							noChgArr[i].splice(1, 1, Number(i)+1)
							
						}
						if (del_detail.length > 0) {
							const params = {'samples':del_detail, 'mid': this.properties.mid};
							this.$axios.patch(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_'))+'/backpre', params).then(res=>{
							}).catch(err=>{console.log(err)})
						}

						this.$refs.sheet.hotInstance.loadData(noChgArr);

						// this.checkedRowData = []
						this.classifyPreDefaultData();
						this.rendertab();
						this.isLoading = false;
					},
					onCancel: () => {
						this.isLoading = false;
						return false;
					}
				});
				this.isWork++;
			},
			/*
			* Experiment Data Check All
			*/
			async checkAll(){
				const checkRow = this.$refs.sheet.hotInstance.getData();
				if(this.isCheckAll){
					this.isCheckAll = false;
				}else{
					this.isCheckAll = true;
				}
				this.sampleData.forEach(a => {
					a[0] = this.isCheckAll;
				});
				this.rendertab();
			},
			/*
			* Experiment Data Check All
			*/
			async sampleDivision(){
				this.openLoading();
				const colCnt = this.$refs.sheet.hotInstance.countRows();
				var checkRow = [];
				let colNum = '';
				let rn = Number(this.$refs.sheet.hotInstance.countRows());
				let idx = '';
				let idxMax = 0;
				let columnIdx = 0;
				colNum = document.getElementById('addNum').value;
				document.getElementById('addNum').value = '';
				idx = 'D';
				columnIdx = Number(common.find_sid_idx(this.sampleHeader, 'divisionidx', this.properties.mid))+3;
				if (colNum == 0) {
					this.$buefy.dialog.alert({
						message: 'Please enter the number of samples to division.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.isLoading = false;
					return false;
				}

				let selecCheck = false;//sample 선택 여부 
				for(let i=0; i < Number(colCnt); i++){
					let bool =this.$refs.sheet.hotInstance.getDataAtCell(i,0);
					if(bool){
						if (common.isNull(this.$refs.sheet.hotInstance.getDataAtCell(i,columnIdx)) || this.$refs.sheet.hotInstance.getDataAtCell(i,columnIdx) == 0) { //분할 샘플 다시 분할하지 못하도록 설정
						} else {
							this.$buefy.dialog.alert({
								message: 'This data has already been division.',
								size: 'is-medium',
								type: 'is-danger'
							})
							this.isLoading = false;
							return false;
						}
					}
				}

				for(let i=0; i < Number(colCnt); i++){
					let bool =this.$refs.sheet.hotInstance.getDataAtCell(i,0);
					if (!this.maxIdx[i]) {
						let max = {'maxDivIdx': common.isNull(this.maxDivIdx[i])? 0 : Number(this.maxDivIdx[i]),'maxReIdx': common.isNull(this.maxReIdx[i])? 0 : Number(this.maxReIdx[i])}
						this.maxIdx.push(max);
					} 
					if(bool){
						selecCheck = true;
						for(let j=0; j < Number(colNum); j++){
							rn += 1;
							checkRow = checkRow.concat(this.$refs.sheet.hotInstance.getSourceData(i, 0, i, Number(this.$refs.sheet.settings.colHeaders.length) - 2));
							checkRow[(checkRow.length-1)][0] = false;
							checkRow[(checkRow.length-1)][1] = Number(rn);
							if (this.maxIdx[i].maxDivIdx == 0) { //기본
								checkRow[(checkRow.length-1)][columnIdx] = Number(this.$refs.sheet.hotInstance.getDataAtCell(i,columnIdx)) + (j+1);
								this.maxIdx[i].maxDivIdx += 1;
							} else {
								checkRow[(checkRow.length-1)][columnIdx] = Number(this.$refs.sheet.hotInstance.getDataAtCell(i,columnIdx)) + 1 +Number(this.maxIdx[i].maxDivIdx);
								this.maxIdx[i].maxDivIdx += 1;
							}
							let colorCode = this.$randomColor();
							let plate_row = (rn)%96 > 0 ? parseInt(rn/96) + 1 : parseInt(rn/96);
							for(let l=0; l < plate_row; l++){
								outer: for(let h=0; h<this.well_column; h++){
									inner: for(let k=0; k<this.well_row; k++){
										let list = document.getElementById('list'+(Number(l)+1)+'-'+(Number(k)+1));
										if(list.childNodes[h].innerText.replace(/[0-9]/g, '') != ''){
											list.childNodes[h].innerText = rn;
											list.childNodes[h].style.color = '#ffffff';
											list.childNodes[h].style.backgroundColor = colorCode;
											checkRow[(checkRow.length-1)][Number(common.find_sid_idx(this.sampleHeader, 'plate'))+3] = (Number(l)+1)+'-'+this.well_row_a[k]+(h+1);
											break outer;
										}
									}
								}
							}
						}
					}
				}
				if (!selecCheck) {
					this.$buefy.dialog.alert({
						message: 'Please select a sample.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.isLoading = false;
					return false;
				}
				checkRow.forEach(a => {
					this.sampleData.push(a);
				});
				this.isWork++;
				this.rendertab();
				this.isLoading = false;
			},
			/*
			* Experiment Data Change Arrary Insert
			*/
			async changeData(source){
				if(this.$refs.sheet.hotInstance){
					this.sampleChangeData = this.$refs.sheet.hotInstance.getData();
				}
				if(arguments[1] === 'edit' || arguments[1] === 'Autofill.fill' || arguments[1] === 'CopyPaste.paste'){ //문제 없음
					//arguments[0][0][3] => 입력값 arguments[0][0][0] => rownum
					if(arguments[0][0][3] != arguments[0][0][0]){ //DNA에서는 일로 탐
						if (!common.isNull(arguments[0][0][3])) {
							this.boolChange = true;
						}
						// this.boolChange = true;
					}else{
						if (Number(arguments[0][0][1]) > 2) {
							if (this.defaultSampleData) {
								if(arguments[0][0][3] != this.defaultSampleData[arguments[0][0][0]][Number(arguments[0][0][1])-1]){
									this.boolChange = true;
								}else{
									this.boolChange = false;
								}
							} else {
								this.boolChange = true;
							}
						} else {
							 this.boolChange = true;
						}
						
					}
				} else if (arguments[1] === 'loadData') { //sample add 후 아무 동작 안하고 save할시에 
					if (this.sampleChangeData) {
						if (arguments[0]) {
							this.boolChange = true;
						} else {
							this.boolChange = false;
						}
					}
				}

				if(this.isWork > 0) this.boolChange = true;

			},
			/*
			* Experiment & Samples Create data
			*/
			async createData(evt, action){
				if (evt) {
					this.openLoading();
				}
				var params = [];
				var sendKey = '';
				var sendValue = '';
				var changeData = [];
				var thisData = [];
				let wellList = [];
				let last_plate = common.find_last_column(this.sampleHeader,'plate');
				let i7id = '';
				let i7seq = '';
				let i5id = '';
                let i5seq = '';
                let seqCheck = [];
				let i7seqCheck = [];
				let i7idCheck = [];
				let i5idCheck = [];
				let i5seqCheck = [];
				let idxBool = false;
				var sidx = 0;	
				var myNum = 2;
				
				if(action == 'confirm'){
					i7id = common.find_last_column(this.sampleHeader,'i7id');
					i7seq = common.find_last_column(this.sampleHeader,'i7seq');
					i5id = common.find_last_column(this.sampleHeader,'i5id');
					i5seq = common.find_last_column(this.sampleHeader,'i5seq');
				}
				
				let plate_row = (this.sampleData.length)%96 > 0 ? parseInt((this.sampleData.length)/96) + 1 : parseInt((this.sampleData.length)/96);
				for(let l=0; l < plate_row; l++){
					for(let j=0; j < this.well_column; j++){
						for(let k=0; k < this.well_row; k++){
							let list = document.getElementById('list'+(Number(l)+1)+'-'+(Number(k)+1));
							if(list.childNodes[j].innerText.replace(/[0-9]/g, '') == ''){
								wellList.push([list.childNodes[j].innerText,this.well_row_a[k],(Number(j)+1), (Number(l)+1)]);
							}
						}
					}
				}
				for(let i in this.sampleData){
				
					for(let j in this.sampleData[i]){
						if(j == 2){
							// set sample : detail id 
							changeData.sid = this.sampleData[i][j];
						}else if(j == this.sampleData[i].length - 1){
							changeData.detailId = this.sampleData[i][j];
							if (this.sampleHeader[Number(j-3)]) {
								changeData[this.sampleHeader[Number(j-3)].columnCode] = this.sampleData[i][j];

							}
						}else if(j > 2){
							changeData[this.sampleHeader[Number(j-3)].columnCode] = this.sampleData[i][j];
							if(this.sampleHeader[Number(j-3)].columnAttr === 'divisionidx'){
								sidx = j;
								let divIdx = 0;
								divIdx = this.sampleData[i][j];
								changeData.divIdx = divIdx;
							}

							if(this.sampleHeader[Number(j-3)].columnAttr === 'reexpidx'){
								sidx = j;
								let reIdx = 0;
								reIdx = this.sampleData[i][j];
								changeData.reIdx = reIdx;
							}

							if(this.sampleHeader[Number(j-3)].columnAttr === 'plate'){ //changeData의 위치정보 확인
								if(last_plate === this.sampleHeader[Number(j-3)].columnCode) {
									for(let k in wellList){
										let plate_point = this.sampleData[i][Number(common.find_last_column_idx(this.sampleHeader, 'plate'))+3];
										let well_plate_point = wellList[k][3]+'-'+wellList[k][1]+wellList[k][2];
										if(well_plate_point === plate_point){
											changeData[this.sampleHeader[Number(j-3)].columnCode] = [wellList[k][3], wellList[k][1], wellList[k][2]];
											wellList.splice(k,1);
											break;
										}
									}
								}
							}
							
						}else if(j == "headerId"){
							changeData.headerId = this.sampleData[i][j];
						}
					}
					thisData.push($.extend(true, {}, changeData));
					changeData = [];
				}

				for (let j in thisData) {
					for (let k in thisData[j]) {
						for (let l in this.sampleHeader) {
							if (this.sampleHeader[l].columnAttr == 'experimentresultcode') {
								for (let p in this.sampleHeader[l].code) {
									if (thisData[j][k] == this.sampleHeader[l].code[p].codeName) {
										thisData[j][k] = this.sampleHeader[l].code[p].codeCode;
									}
								}
							}
						}
					}
					if(!common.isNull(i7id) && !common.isNull(i7seq) && !common.isNull(i5id) && !common.isNull(i5seq)){
						seqCheck.push(thisData[j][i7seq]+'_'+thisData[j][i5seq])
					}
				}
				if(!common.isNull(i7id) && !common.isNull(i7seq) && !common.isNull(i5id) && !common.isNull(i5seq)){
					if(seqCheck.length != Array.from(new Set(seqCheck)).length) idxBool = true;
				}

				params = { 
					'msid': this.msid,
					'uid': this.properties.uid,
					'ssid': this.ssid,
					'samples': thisData,
					'preStatus' : common.preStatus(this.properties.mid,this.menuData),
					'preStatusA' : common.preStatus(this.properties.mid,this.menuData)
				}
				for(let i in this.experimentHeader){
					sendKey = this.experimentHeader[i].columnCode;
					if (this.experimentHeader[i].columnType == 'DATERANGE') {
						sendValue = common.dataRangeWork(this.experimentHeader[i], this.experimentData)
					} else {
						sendValue = this.experimentData[this.experimentHeader[i].columnCode];
					}
					if(this.experimentData[this.experimentHeader[i].columnCode] != this.defaultExperimentData[this.experimentHeader[i].columnCode]){
						this.boolChange = true;
					}

					if(sendValue){
						params[sendKey] = sendValue
					}
				}
				let requiredHeader = common.findRequiredByHeader(this.experimentHeader) //리스트 필수값
				for (let i in requiredHeader) { //필수값 벨리데이션
					let check = Object.keys(params).find(item => item == requiredHeader[i].columnCode);
					if (!check) {
						this.$buefy.dialog.alert({
							message: 'Please Enter '+ requiredHeader[i].columnName,
							size: 'is-medium',
							type: 'is-danger'
						})
						this.isLoading = false;
						return false;
					}
				}
				// 데이터 변경이 있는 경우에만 저장
				if(this.boolChange){
					
					//dna, mediage
					// if (idxBool) {
					// 	this.isLoading = false;
					// 	this.$buefy.dialog.alert({
					// 		message: 'There are duplicate indexes.',
					// 		size: 'is-medium',
					// 		type: 'is-danger'
					// 	});
					// 	return false;
					// }

					// if (this.subName === 'DNA') {
					// 	this.$axios.post(this.$apiHost+'/exapi/mediexp', params).then(res=>{
					// 		if (res.data.flag) {
					// 			this.$buefy.notification.open({
					// 				duration: 2000,
					// 				message: res.data.message,
					// 				position: 'is-bottom-right',
					// 				type: 'is-success',
					// 				hasIcon: true
					// 			})
					// 		} else {
					// 			this.$buefy.notification.open({
					// 				duration: 2000,
					// 				message: res.data.message,
					// 				position: 'is-bottom-right',
					// 				type: 'is-danger',
					// 				hasIcon: true
					// 			})
					// 		}
					// 	})
					// 	.catch(err=>{
					// 		if(err){
					// 			this.isLoading = false;
					// 			this.$buefy.dialog.alert({
					// 				message: 'The system failed and the save  failed. Please contact your system administrator.',
					// 				size: 'is-medium',
					// 				type: 'is-danger'
					// 			})
					// 		}						
					// 		console.log(err)
					// 	});
                    // }
                    
					this.$axios.post(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_')), params).then(res=>{
						sessionStorage.setItem('uid',res.data.uid);
						this.properties.uid = res.data.uid;
						this.boolChange = false;
						this.upload();
						this.pdfUpload();
						this.nanoUpload();
						this.tapeUpload();
						this.bioUpload();
						let delayTime = 1000;
						if (this.bioFileHandleFlag || this.bioId.length > 0) {
							delayTime = 4000;
						}
						const timeoutObj = setTimeout(async () => {
							if (evt) {
								this.isLoading = false;
								this.$router.go({name:this.$route.name});
							} else {
								if (action == 'confirm') {
									this.isLoading = false;
									this.confirmData();
								} else if (action == 'approval') {
									this.isLoading = false;
									this.approval();
								}
							}
						}, delayTime);
					})
					.catch(err=>{
						if(err){
							this.isLoading = false;
							this.$buefy.dialog.alert({
								message: 'The system failed and the save failed. Please contact your system administrator.',
								size: 'is-medium',
								type: 'is-danger'
							})
						}						
						console.log(err)
					});
				}else{
					this.isLoading = false;
					this.$buefy.dialog.alert({
						message: 'No data has been changed. Can not save.',
						size: 'is-medium',
						type: 'is-danger'
					})
					return false;
				}
			},
			async deleteData() {
				this.$buefy.dialog.confirm({
					message: 'Would you like to delete?',
					size: 'is-medium',
					onConfirm: async () => {
						const colCnt = this.$refs.sheet.hotInstance.countRows();
						const deleteArr = [];
						const delData = [];
						let params = [];
						for(let i=0; i < Number(colCnt); i++){
							deleteArr[i] = this.$refs.sheet.hotInstance.getData(i,Number(this.$refs.sheet.hotInstance.countCols())-1,i,0)[0];
						}
						for (let i in deleteArr) {
							let del = {
								'sampleId'	: deleteArr[i][2],
								'detailId'	: deleteArr[i][Number(this.$refs.sheet.settings.columns.length)-1],
								'division'	: deleteArr[i][Number(common.find_sid_idx(this.sampleHeader, 'divisionidx'))+3],
								'reexp'		: deleteArr[i][Number(common.find_sid_idx(this.sampleHeader, 'reexpidx'))+3]
							}
							delData.push(del);
						}
	
						params = {'delData':delData, 'hId':this.properties.uid};
						this.$axios.patch(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_'))+'/delete', params)
						.then(res=>{
							if (res.data) {
								this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list'}});
							}
						})
					
					},
					onCancel: () => {
						this.isLoading = false;
						return false;
					}
				});
			},
			/*
			* List page Move (리스트 목록 페이지 이동)
			*/
			goPage() {
				if(this.boolChange){
					this.$buefy.dialog.confirm({
						message: 'You have changed data. Would you like to leave?',
						size: 'is-medium',
						onConfirm: async () => {
							sessionStorage.removeItem('uid');
							this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list'}});
						},
						onCancel: () => {
							return false;
						}
					});
				}else{
					this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list'}});
				}
			},
			/*
			* buefy 테이블 현재 토글 디테일 창 열기
			*/
			toggle(row) {
				// 본인 토글 창이 열려있을때 창 닫기.. b-table 설정에 defaultOpenedDetails 배열은 현재 열린 창이 입력 되도록 되어 있음
				if(row.id === this.defaultOpenedDetails[0]){
				this.defaultOpenedDetails = []
				}else{ // 토글 창이 닫혀있을때 실행
				this.$refs.table.toggleDetails(row);
				this.defaultOpenedDetails = [row.id]
				}
				this.preSampleSetting();
			},
			/*
			* buefy 테이블 이전 토글 디테일 창 닫기 b-table 설정에 toggle 창 실행 시 이전 창은 닫히고 현재 선택 창이 열리도록 설정 되어 있음
			*/
			closeAllOtherToggle(row, index) {
				this.defaultOpenedDetails = []
				this.defaultOpenedDetails = [row.id]
			},
			/*
			* handsontable 문제가 있음 화면에 정상 랜더링이 아니면 화면이 나타나지 않음 그래서 setTimeout으로 2번 실행하여 랜더링 위치 잡는 함수
			*/
			rendertab() {
				// height 는 Hansontable이 height를 설정하지 않으면 Handsontable event 가 일어날때마다 계속 height가 무한정 늘어남
				// hotInstance의 updateSettings를 사용하여 기본 setting 값을 수정 한다.
				if(this.sampleData.length > 0){
					// plate 위치 변경 확인
					let last_plate_idx = common.find_last_column_idx(this.sampleHeader, 'plate'); // 마지막 plate 위치 확인
					let plate_chg = common.plateDataChange(this.well_plate, Number(last_plate_idx)+3, this.sampleData);
					let height = (Number(this.height) - 345)+'px';
					plate_chg.forEach((a)=>{
						this.sampleData[a[0]][Number(last_plate_idx)+3] = a[1]
					});
					// handsontable render 기본 높이 구하기
					// let height = (((this.$refs.sheet.hotInstance.countRows()) * 34)+50+100)+'px';
					// this.$refs.sheet.hotInstance.updateSettings({height:height})
					this.$refs.sheet.hotInstance.updateSettings({height:height})

					const rows = (this.$refs.sheet.hotInstance.countRows() / 10) + 1;
					for(let i = 0; i < rows ;i++){
						setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
						// this.$refs.sheet.hotInstance.render();
					}
				}
			},
			/*
			* Plate div 보이기/숨기기
			*/
			ptshow(){
				if(this.b_sh_well) this.b_sh_well = false;
				else this.b_sh_well = true;
			},
			/*
			* 플레이트 탭 선택 시 실행 되는 함수
			*/
			async platetab() {
				// sortable.js 를 사용하여 Plate well 을 그린다.
				// row, column 수 만큼 그린다. 아직 UI 부분은 더 수정 해야함 (19.09.19 기준)
				// onEnd 에서는 드래그앤드랍 이후 위치 text를 변경 해주도록 설정
				this.boolChange = true;

				let sampleData = this.sampleData;
				let addData = this.addData;
				let last_plate_idx = common.find_last_column_idx(this.sampleHeader, 'plate') + 3; // 마지막 plate 위치 확인 (checkbox, no, id hidden +3 해준다)
				for(let j in this.well_plate){
					for(let i=0; i<this.well_row; i++){
						let listname = 'list'+this.well_plate[j]+'-';
						let list = document.getElementById(listname+(Number(i)+1));
						Sortable.create(list, {
							group: {
								name: 'shared',
								pull: true,
								put: true // Do not allow items to be put into this list
							},
							sort: true,
							swap: true,
							// multiDrag: true,
							animation: 150,
							onEnd: function (/**Event*/evt) {
								let thisItemHTML = evt.item.outerHTML;
								let swapItemHTML = evt.swapItem.outerHTML;
								let thisId = evt.item.innerText;
								let swapId = evt.swapItem.innerText;
								let f_id = evt.from.id.substring(0,evt.from.id.indexOf('-'));
								// let t_id = evt.to.id.substring(0,evt.to.id.indexOf('-'));
								let t_id = evt.swapItem.parentElement.id.substring(0,evt.swapItem.parentElement.id.indexOf('-'));

								let f_id_b = evt.item.id;
								let t_id_b = evt.swapItem.id;
							
								// flist.childNodes[j].innerText.replace(/[0-9]/g, '')
								let fidx = f_id.substring(4);
								let tidx = t_id.substring(4);

								common.plateReload(evt.from.id, f_id_b, evt.swapItem.parentElement.id, t_id_b);

								let thisPlate = common.isNull(thisId.replace(/[0-9]/g, '')) ? sampleData[Number(thisId)-1][last_plate_idx] : fidx+'-'+thisId;
								let swapPlate = common.isNull(swapId.replace(/[0-9]/g, '')) ? sampleData[Number(swapId)-1][last_plate_idx] : tidx+'-'+swapId;
								if(common.isNull(thisId.replace(/[0-9]/g, ''))){
									sampleData[Number(thisId)-1].splice(last_plate_idx, 1, swapPlate);
								}else{
									
								}
								if(common.isNull(swapId.replace(/[0-9]/g, ''))){
									sampleData[Number(swapId)-1].splice(last_plate_idx, 1, thisPlate);
								}else{

								}

							},
						});
					}
				}
			 },
			/*
			* gel image file upload
			*/
			async fileSelect(name, files) {
				if (files.length != 0) {
					this.boolChange = true;
					this.uFlag = true;
				}
				document.getElementById('countImg').innerHTML = files.length + ' file(s) selected';
			},
			async onPaste(evt) {
				this.pasteFlag = true;
				let file = evt.clipboardData.files[0];
				if (file) {
					this.boolChange = true;
					this.pasteForm.append('file', file);
					let reader = new FileReader();
					var imgtag = document.getElementById("pasteImg");
					reader.onloadend = function () {
						imgtag.src = reader.result;
					}
					this.pasteCount++;

					reader.readAsDataURL(file);
					document.getElementById('countPasteImg').innerHTML = this.pasteCount + ' file(s) selected';
				} else {
					this.$buefy.dialog.alert({
						message: 'Please paste only the file',
						size: 'is-medium',
						type: 'is-danger'
					})
				}
			},
			async onNanoPaste(evt) {
				this.pasteNanoFlag = true;
				let file = evt.clipboardData.files[0];
				if (file) {
					this.boolChange = true;
					this.pasteNanoForm.append('file', file);
					let reader = new FileReader();
					var imgtag = document.getElementById("pasteNano");
					reader.onloadend = function () {
						imgtag.src = reader.result;
					}
					this.pasteNanoCount++;
					reader.readAsDataURL(file);
					document.getElementById('countPasteNano').innerHTML = this.pasteNanoCount + ' file(s) selected';
				} else {
					this.$buefy.dialog.alert({
						message: 'Please paste only the file',
						size: 'is-medium',
						type: 'is-danger'
					})
				}
			},
			async upload() {
				if (this.imgFileHandleFlag || this.pasteFlag || this.imgId.length > 0) {
					try {
						let formData = new FormData();
						if (this.imgFileHandleFlag) {
							formData = this.imgFileFormData;
						} 
						if (this.pasteFlag) {
							for (let pair of this.pasteForm.entries()) {
								formData.append(pair[0], pair[1]);
							}
						}
						formData.append('uid', this.properties.uid);
						formData.append('copyId', this.imgId);
						formData.append('gubun', 'gel');
						await this.$axios.post(this.$apiHost +'/'+this.$route.name.replace('_detail','')+'/upload', formData, {
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							}
						}).then(console.log('then')).catch(err=>{console.log(err)})
						return false;
					} catch (error) {
						console.log(error)						
						return false;
					}
				}
			},
			/*
			* gel image file select
			*/
			async getImgFile() {
				//img 가져오기
				if(!common.isNull(this.properties.uid)){
					var params = []; 
					params = {'uid' : this.properties.uid};
					var request = {params : params}
					await this.$axios.get(this.$apiHost +'/'+this.$route.name.replace('_detail','')+'/getimage', request)
					.then(res=>{
						for (let i in res.data) {
							if (res.data[i].classification === 'gel') {
								this.imgData.push(res.data[i]);
							} else {
								this.nanoData.push(res.data[i]);
							}
						}
						if (!common.isNull(this.imgData)) {
							for (let i in this.imgData) {
								this.imgId.push(this.imgData[i].id);
								let image = this.imgData[i].img;
							}
						}
						if (!common.isNull(this.nanoData)) {
							for (let i in this.nanoData) {
								this.nanoId.push(this.nanoData[i].id);
								let image = this.nanoData[i].img;
							}
						}
					}).catch(err=>{console.log(err)});
				} 
			},
			/*
			* gel image file delete
			*/
			async deleteImgFile(param) {
				try {
					var params = []; 
					params = {'id' : param.id};
					var request = {params : params}
					if (param.gubun === 'gel') {
						this.imgId.splice(this.imgId.indexOf(param.id),1);
					} else {
						this.nanoId.splice(this.nanoId.indexOf(param.id),1);
					}
					if (!common.isNull(param.id)) {
						await this.$axios.delete(this.$apiHost + '/'+this.$route.name.replace('_detail','') + '/delimage', request)
						.then(res => {
							if (res.data) {
								this.$buefy.dialog.alert({
									message: 'Complete!',
									size: 'is-medium',
									type: 'is-danger'
								})
							return false;
							}
						});
					}
				} catch (error) {
					console.log(error)
				}
			},

			async nanoUpload() {
				if (this.nanoFileHandleFlag || this.pasteNanoFlag || this.nanoId.length > 0) {
					try {
						let formData = new FormData();
						if (this.nanoFileHandleFlag) {
							formData = this.nanoFileFormData;
						} 
						if (this.pasteNanoFlag) {
							for (let pair of this.pasteNanoForm.entries()) {
								formData.append(pair[0], pair[1]);
							}
						}
						formData.append('uid', this.properties.uid);
						formData.append('copyId', this.nanoId);
						formData.append('gubun', 'nano');
						await this.$axios.post(this.$apiHost +'/'+this.$route.name.replace('_detail','')+'/upload', formData, {
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							}
						}).then(console.log('then')).catch(err=>{console.log(err)})
						return false;
					} catch (error) {
						console.log(error)						
						return false;
					}
				}
			},
			/*
			* gel image file select
			*/
			async getNanoFile() {
				//img 가져오기
				if(!common.isNull(this.properties.uid)){
					var params = []; 
					params = {'uid' : this.properties.uid};
					var request = {params : params}
					await this.$axios.get(this.$apiHost +'/'+this.$route.name.replace('_detail','')+'/getimage', request)
					.then(res=>{
						this.nanoData = res.data;
						if (!common.isNull(this.nanoData)) {
							for (let i in this.nanoData) {
								this.nanoId.push(this.nanoData[i].id);
								let image = this.nanoData[i].img;
							}
						}
					}).catch(err=>{console.log(err)});
				} 
			},
			/*
			* gel image file delete
			*/
			async deleteNanoFile(id) {
				try {
					var params = []; 
					params = {'id' : id};
					var request = {params : params}
					this.nanoId.splice(this.nanoId.indexOf(id),1);
					if (!common.isNull(id)) {
						await this.$axios.delete(this.$apiHost + '/'+this.$route.name.replace('_detail','') + '/delimage', request)
						.then(res => {
							if (res.data) {
								this.$buefy.dialog.alert({
									message: 'Complete!',
									size: 'is-medium',
									type: 'is-danger'
								})
							return false;
							}
						});
					}
				} catch (error) {
					console.log(error)
				}
			},

			/*
			* tapeStation file upload
			*/
			async tapeUpload() {
				if (this.tapeFileHandleFlag || this.tapeId.length > 0) {
					try {
						let formData = new FormData();
						if (this.tapeFileHandleFlag) {
							formData = this.tapeFileFormData;
						} 
						formData.append('uid', this.properties.uid);
						formData.append('ssid', this.ssid);
						formData.append('copyId', this.tapeId);
						await this.$axios.post(this.$apiHost +'/'+this.$route.name.replace('_detail','')+'/tape', formData, {
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							},
						})
						return false;
					} catch (error) {
						console.log(error)						
						return false;
					}
				}
			},
			// QC Report
			async pdfUpload() {
				if (this.pdfFileHandleFlag || this.pdfId.length > 0) {
					try {
						let formData = new FormData();
						if (this.pdfFileHandleFlag) {
							formData = this.pdfFileFormData;
						} 
						formData.append('uid', this.properties.uid);
						formData.append('ssid', this.ssid);
						formData.append('copyId', this.pdfId);

						await this.$axios.post(`${this.$apiHost}/files/report`, formData, {
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							},
						})
						return false;
					} catch (error) {
						console.log(error)						
						return false;
					}
				}
			},
			
			/*
			* gel image file select
			*/
			async getTapeFile() {
				//img 가져오기
				if(!common.isNull(this.properties.uid)){
					var params = []; 
					params = {'uid' : this.properties.uid};
					var request = {params : params}
					await this.$axios.get(this.$apiHost +'/'+this.$route.name.replace('_detail','')+'/gettape', request).then(res=>{
						this.tapeData = res.data;
						this.tapeData.sort((a, b) => {
							return Number(a.sampleId.substr(a.sampleId.length-4)) - Number(b.sampleId.substr(b.sampleId.length-4));
						})
						if (!common.isNull(this.tapeData)) {
							for (let i in this.tapeData) {
								this.tapeId.push(this.tapeData[i].id);
							}
						}
					});
				} 
			},
			/*
			* gel image file delete
			*/
			async deleteTapeFile(id) {
				// this.$buefy.dialog.confirm({
				//	 message: 'Would you like to delete?',
				//	 size: 'is-medium',
				//	 onConfirm: async () => {
						//사진 지우는거 보여주기
						// var del = document.getElementById('tapeBox'+i);
						// del.remove();
						//img delete 
				try {
					var params = []; 
					params = {'id' : id};
					var request = {params : params}
					this.tapeId.splice(this.tapeId.indexOf(id),1);
					if (!common.isNull(id)) {
						await this.$axios.delete(this.$apiHost + '/'+this.$route.name.replace('_detail','') + '/deltape', request).then(res => {
							if (res.data) {
								this.$buefy.dialog.alert({
									message: 'Complete!',
									size: 'is-medium',
									type: 'is-danger'
								})
								return false;
							}
						});
					}
				} catch (error) {
					console.log(error)
				}
					// },
					// onCancel: () => {
					//	 id ='';
					// }
				// });
			},
			async bioUpload() {
				if (this.bioFileHandleFlag || this.bioId.length > 0) {
					try {
						let formData = new FormData();
						if (this.bioFileHandleFlag) {
							formData = this.bioFileFormData;
						} 
						formData.append('uid', this.properties.uid);
						formData.append('ssid', this.ssid);
						formData.append('copyId', this.bioId);
						await this.$axios.post(this.$apiHost +'/'+this.$route.name.replace('_detail','')+'/bio', formData, {
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							},
						})
						return false;
					} catch (error) {
						console.log(error)						
						return false;
					}
				}
			},
			/*
			* gel image file select
			*/
			async getBioFile() {
				//img 가져오기
				if(!common.isNull(this.properties.uid)){
					var params = []; 
					params = {'uid' : this.properties.uid};
					var request = {params : params}
					await this.$axios.get(this.$apiHost +'/'+this.$route.name.replace('_detail','')+'/getbio', request).then(res=>{
						this.bioData = res.data;
						this.bioData.sort((a, b) => {
							return Number(a.sampleId.substr(a.sampleId.length-4)) - Number(b.sampleId.substr(b.sampleId.length-4));
						})
						if (!common.isNull(this.bioData)) {
							for (let i in this.bioData) {
								this.bioId.push(this.bioData[i].id);
							}
						}
					});
				} 
			},
			/*
			* gel image file delete
			*/
			async deleteBioFile(id) {
				// this.$buefy.dialog.confirm({
				//	 message: 'Would you like to delete?',
				//	 size: 'is-medium',
				//	 onConfirm: async () => {
						//사진 지우는거 보여주기
						// var del = document.getElementById('tapeBox'+i);
						// del.remove();
						//img delete 
				try {
					var params = []; 
					params = {'id' : id};
					var request = {params : params}
					this.bioId.splice(this.bioId.indexOf(id),1);
					if (!common.isNull(id)) {
						await this.$axios.delete(this.$apiHost + '/'+this.$route.name.replace('_detail','') + '/delbio', request).then(res => {
							if (res.data) {
								this.$buefy.dialog.alert({
									message: 'Complete!',
									size: 'is-medium',
									type: 'is-danger'
								})
								return false;
							}
						});
					}
				} catch (error) {
					console.log(error)
				}
					// },
					// onCancel: () => {
					//	 id ='';
					// }
				// });
			},
			/*
			* gel pipeline info
			*/
			async getPipeline() {
				try{
					// let params = {};
					// const data = common.menuHeader_route('pipelines', this.menuData, 1);
					// params['mid'] = data[5];
					// params[data[3].find(a=>a.columnAttr === 'usedcode').columnCode] = 1;
					// let request = { params: params };
					// await this.$axios.get(this.$apiHost + '/pipelines/search', request).then(res => {
					// 	res.data.list.forEach(a=>this.pipeline.push({id: a.id, name: a[data[3].find(a=>a.columnAttr === 'name').columnCode]}));
					// }).catch(err=>{console.log(err)});
				}catch(error){
					console.log(error);
				}
			},
			async reportEditor() {
				try{
					const colCnt = Number(this.$refs.sheet.hotInstance.countRows());
					let samples = {...this.experimentData};
					let sampleData = [];

					for (let i = 0; i < colCnt; i++) {
						let bool = this.$refs.sheet.hotInstance.getDataAtCell(i,0);
						if (bool) sampleData.push(this.editorSampleData[i]);
					}
					
					if (this.sampleData.length == 0) {
						this.$buefy.dialog.alert({
							message: 'Please select a sample.',
							size: 'is-medium',
							type: 'is-danger'
						})
						return false;
					}

					this.$router.push({ name: 'editor', params: {experimentHeader:this.experimentHeader, experimentData:samples, menuData:this.menuData, sampleData:sampleData, dprops:this.properties, type:'list'}})
				
				}catch(error){
					console.log(error);
				}
			},
			
			
			/*
			* confirm Data page Move
			*/
			async confirmData() {
				if (this.boolChange) {
					this.createData(false, 'confirm');
					return false;
				} 
				if (this.properties.uid) {
					
					this.$buefy.dialog.confirm({
						message: 'Are you sure you want to confirm?',
						size: 'is-medium',
						onConfirm: async () => {
							for (let i in this.sampleData) {
								if (common.isNull(this.sampleData[i][common.findIdxByAttr(this.sampleHeader, 'experimentresultcode')+3])) {
									this.$buefy.dialog.alert({
										message: 'Please enter the result.',
										size: 'is-medium',
										type: 'is-danger'
									})
									return false;
								}
							}
							this.openLoading();
							
							const uid = this.properties.uid;
							const mid = this.properties.mid
							let colCnt = this.$refs.sheet.hotInstance.countRows();
							let detailIds = [];
							for(let i=0; i < Number(colCnt); i++){
								detailIds.push(this.$refs.sheet.hotInstance.getDataAtCell(i,this.sampleData[i].length-1));
							}
							this.$axios.patch(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/confirm', {
							uid, detailIds, mid
							})
							.then((res) => {
								sessionStorage.setItem('uid',uid);
								this.isLoading = false;
								this.$router.push({name:'experiments_completion',params:{mid:this.properties.mid,uid:uid,type:'detail'}});
							});
						},
						onCancel: () => {
							this.isLoading = false;
							return false;
						}
					});
				} else {
					this.createData(false, 'confirm');
					return false;
				}
			},
			/*
			* confirm Data page Move
			*/
			async classifyWorkChange(mid) {
				if(this.premid != mid){
					this.premid = mid;
					this.re_expid = mid;
					this.classifyPreDefaultData(true);
				}
			},
			/*
			* page Loading bar
			*/
			openLoading() {
				this.isLoading = true
				// setTimeout(() => {
				// 	this.isLoading = false
				// }, 10 * 100)
			},
			/*
			* Handsontable Reception no cell render
			*/
			anchorRenderer(instance, td, row, col, prop, value, cellProperties) {
				Handsontable.renderers.TextRenderer.apply(this, arguments);
				let anchor = null;
				anchor = document.createElement("a");
				anchor.href='#modal5'
				anchor.setAttribute("data-toggle","modal");
				anchor.text = value;
				const sendId = this.sendId;
				const sampleData = this.experimentData.samples;
				anchor.onclick = function() {
					sendId(sampleData[row].id);
				};
				Handsontable.dom.empty(td);
				td.appendChild(anchor);
			},
			/*
			* Handsontable Reception no cell render
			*/
			figureRenderer(instance, td, row, col, prop, value, cellProperties) {
				Handsontable.renderers.TextRenderer.apply(this, arguments);
				let columnData = this.sampleHeader[prop-3]; 
				if (columnData.limitMinInEquality == '<' && columnData.limitMaxInEquality == '<') {
					if (columnData.limitMinvalue < Number(value) && Number(value) < columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '<=' && columnData.limitMaxInEquality == '<=') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '<=' && columnData.limitMaxInEquality == '<') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '<' && columnData.limitMaxInEquality == '<=') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '>' && columnData.limitMaxInEquality == '>') {
					if (columnData.limitMinvalue < Number(value) && Number(value) < columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '>=' && columnData.limitMaxInEquality == '>=') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '>=' && columnData.limitMaxInEquality == '>') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '>' && columnData.limitMaxInEquality == '>=') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '>' && columnData.limitMaxInEquality == '<') {
					if (columnData.limitMinvalue < Number(value) && Number(value) < columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '>=' && columnData.limitMaxInEquality == '<=') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else  if (columnData.limitMinInEquality == '>=' && columnData.limitMaxInEquality == '<') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					}
				} else if (columnData.limitMinInEquality == '>' && columnData.limitMaxInEquality == '<=') {
					if (columnData.limitMinvalue <= Number(value) && Number(value) <= columnData.limitMaxvalue) {
					} else {
						td.style.color = '#FA5858';
						td.style.backgroundColor = '#FBEFF2';
					} 
				} 
			},
			/*
			* Handsontable Reception no click is chat.vue send uuid
			*/
			sendId(id){
				bus.$emit("receptid", id);
			},
			approval() {
				if (this.properties.uid) {
					this.$buefy.dialog.confirm({
						message: 'Are you sure you want to request for approval?',
						size: 'is-medium',
						onConfirm: async () => {
							const uid = this.properties.uid;
							const mid = this.properties.mid;
							const userData = this.userData;
		
							this.$axios.patch(this.$apiHost + '/approvals/approval', {
								uid, mid, userData
							})
							.then((res) => {
								sessionStorage.setItem('uid',uid);
								this.isLoading = false;
								this.$router.push({name:'experiments_completion',params:{mid:this.properties.mid,uid:uid,type:'detail'}});
							});
						},
						onCancel: () => {
							this.isLoading = false;
							return false;
						}
					});
				} else {
					this.createData(false, 'approval');
				}
			},
			onScroll(e) {
				// console.log(window.top.scrollY); /* or: e.target.documentElement.scrollTop */
				// let htclone = document.getElementsByClassName('ht_clone_top');
				// if(window.top.scrollY > 360)htclone[0].classList.add('hdfixed');
				// else htclone[0].classList.remove('hdfixed');
				if(window.top.scrollY > 360) $('.ht_clone_top').css('top', (window.top.scrollY-330)+'px');
				else $('.ht_clone_top').css('top', '0px');
			},
			handleResize() {
				this.width = window.innerWidth;
				this.height = window.innerHeight;
			},
			classifyReExpData() {
				//classifying ReExperiment tab data(column, row data, present menu, ...)

			},
		},
		computed: {
			sheetSettings() {
				let settings = this.$store.getters.sheetSettings;
				return settings;
			},
			preSampleSetting() {
				return this.classifyPreSampleHeader;
			},
			preSetting() {
				return this.classifyPreHeader;
			},
			
		},
		watch: {
			checkedRows: function() {
				// 상위 테이블 선택 한경우 this.checkedRowData에 무조건 Insert
				const validVisibleData = this.$refs.table.visibleData.filter((row, idx) => {
					if(this.$refs.table.isRowChecked(row)){
						this.checkedRowData = this.checkedRowData.concat(common.makeData(this.preDefaultSampleData[idx], 1, this.addData));
						common.a_overlap_c(this.checkedRowData);
					}else{
						let data = common.makeData(this.preDefaultSampleData[idx], 1, this.addData);
						data = data.filter((s_row, s_idx)=>{
							for(let i in this.checkedRowData){
								if(this.checkedRowData[i].hasOwnProperty('detailId') && s_row.hasOwnProperty('detailId')){
									if(this.checkedRowData[i].detailId === s_row.detailId){
										this.checkedRowData.splice(i, 1);
									}
								}else{
									if(this.checkedRowData[i].sampleId === s_row.sampleId){
										this.checkedRowData.splice(i, 1);
									}
									if(this.checkedRowData[i].gid === s_row.gid){
										this.checkedRowData.splice(i, 1);
									}
								}

							}
						});
					}
				});
				// 하위 테이블 데이터 새로 고침
				// this.classifyPreSampleData(row);
				this.classifyPreSampleData();
			},
			sampleCheckedRows: function(){
				// 하위 데이터가 모조건 전체 선택인 경우 실행 (현재 기준 19.08.29 15시)
				for(let i in this.$refs.table.visibleData){ 
					// 하위 sample 데이터의 갯수에 따른 상위 데이터 체크 박스 해제 기능
					if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[i])){ // 상위 테이블 체크 여부 확인
						if(this.preSampleData.length > this.sampleCheckedRows.length){ // sample 데이터와 sample 체크 데이터 비교 조건
							for(let i in this.$refs.table.newCheckedRows){ // 상위 체크 데이터 loop
								if(this.preSampleData[0].gid === this.$refs.table.newCheckedRows[i].id){ // sample 데이터의 gid와 상위 체크 데이터 같은 경우 상위 데이터 splice
									this.$refs.table.newCheckedRows.splice(i, 1);
								}
							}
						}
					}
					// 하위 테이블 체크 박스 모두 선택 인 경우 상위 테이블의 체크 박스 추가 기능
					if(this.$refs.preSampleTable != null){ // 하위 체크 박스 선택 여부 확인 (event로 구분했음 향후 변경 필요 함)
						if(this.$refs.sampleTable.isAllChecked){ // 하위 테이블의 체크 박스 전체 선택 여부 확인
							if(this.preSampleData[0].gid === this.$refs.table.visibleData[i].id){ // sample 데이터와 sample 체크 데이터 비교 조건
								this.$refs.table.newCheckedRows.push(this.$refs.table.visibleData[i]); // 없는 경우 추가
							}
						}
					}
				}
				// Add 데이터 생성
				this.checkedRowData = this.checkedRowData.concat(this.sampleCheckedRows); // 전체 넣기
				common.a_overlap_c(this.checkedRowData); // 중복 제거 common make function
				if(this.sampleCheckedRows.length != this.preSampleData.length){ // 전체 아닌 경우 Add 데이터 생성
					if(this.$refs.preSampleTable != null){ // preSampleTable의 이벤트를 체크 (단 event의 path값 변경되면 수정 해주어야 함)
						let checkedIdx = [];
						this.checkedRowData  = this.checkedRowData.filter((a, b)=>{ // for 문 대신 filter로 구분 for 문이랑 같은 기능 reduce 도 있음
							this.preSampleData = this.preSampleData.filter((c, d)=>{ // checkRowData 와 preSampleData 의 sampleId를 비교
								// detailId key가 없는 경우 비교
								if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
									if(a.detailId === c.detailId){
										if(!this.$refs.preSampleTable.isRowChecked(c)){ // row의 check box 가 true false 구분
											checkedIdx.push(b); // 함수 내 checkedIdx 변수에 위치 값 push (이유는 아래에..)
										}
									}
								}else{
									if(a.sampleId === c.sampleId){
										if(!this.$refs.preSampleTable.isRowChecked(c)){ // row의 check box 가 true false 구분
											checkedIdx.push(b); // 함수 내 checkedIdx 변수에 위치 값 push (이유는 아래에..)
										}
									}
								}
								return this.preSampleData; // 이 값은 변경 하는것이 아니므로 그대로 return
							});
							return this.checkedRowData; // 이 값은 변경 하는것이 아니므로 그대로 return
						});
						checkedIdx.sort((a,b)=>{return b - a}) // 해당 변수를 역순으로 sort
						if(checkedIdx.length > 0){ // 이부분이 중요. 아래 조건문의 splice 는 해당 배열 값을 삭제 한다. 단 순차적으로 삭제하면 삭제한 row가 없어져 에러가 난다 (아래 계속)
							for(let i in checkedIdx){ // (아래 계속) 그래서 역순으로 정렬하여 배열의 마지막 값 부터 삭제 한다. 간단하지만 꼭 기억해야함.
								this.checkedRowData.splice(checkedIdx[i], 1);
							}
						}
					}
				}
				// // 개별 선택 체크 박스를 true로 바꾸는 작업
				if(this.sampleCheckedRows.length === 0 && this.checkedRowData.length > 0){
					this.checkedRowData  = this.checkedRowData.filter((a, b)=>{ // for 문 대신 filter로 구분 for 문이랑 같은 기능 reduce 도 있음
						this.preSampleData = this.preSampleData.filter((c, d)=>{ // checkRowData 와 preSampleData 의 sampleId를 비교
							if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
								if(a.detailId === c.detailId){
									this.sampleCheckedRows.push(c);
								}
							}else{
								if(a.sampleId === c.sampleId){
									this.sampleCheckedRows.push(c);
								}
							}
							return this.preSampleData; // 이 값은 변경 하는것이 아니므로 그대로 return
						});
						return this.checkedRowData; // 이 값은 변경 하는것이 아니므로 그대로 return..
					});
				}
			},
			sampleData: function(){
			},
			preHeader: function(){
			},
		},
	}

</script>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>


// WEBPACK FOOTER //
// src/views/Experiment/DetailForm.vue